<template>
    <Toast />
    <Sidebar v-model:visible="showMessageSidebar" position="right" style="width: 60%;" :modal="true"
        @hide="closeMessageSidebar" :showCloseIcon="false" class="message-sidebar">
        <template #header>
            <div class="custom-sidebar-header">
                <div v-if="!isCreatingMessage" class="sidebar-header-left">
                    <div class="sidebar-header-title">Messages</div>
                    <Button class="icon-btn" icon="pi pi-plus" @click="startNewMessage" />
                </div>
                <div class="sidebar-header-right">
                    <div class="sidebar-header-right-container" v-if="isCreatingMessage">
                        <div class="sidebar-header-title">Create Messages</div>
                        <Button class="close-btn" icon="pi pi-times" @click="closeMessageSidebar" />
                    </div>
                    <div class="sidebar-header-right-container-close" v-else>
                        <Button class="close-btn" icon="pi pi-times" @click="closeMessageSidebar" />
                    </div>
                </div>
            </div>
        </template>
        <Messaging ref="messagingComponent" @close="closeMessageSidebar" :message="selectedMessage"
            v-model:isCreating="isCreatingMessage" :encryptionId="opportunityId" />
    </Sidebar>

    <!-- Contract Creation Instruction for Status 6 -->
    <div v-if="opportunityDetails?.status === 6 && opportunityDetails?.rfp_uuid !== null" class="contract-instruction">
        <!-- Partner Contract Instructions -->
        <div class="partner-contract-instructions">
            <div class="partner-contract-header">
                <i class="pi pi-file-edit contract-icon"></i>
                <h4>You will drive the contracting process from here. Let's get started!</h4>
            </div>

            <div class="partner-contract-steps">
                <div class="contract-step">
                    <h5>Step 1: Review and Edit the Contract Draft</h5>
                    <a href="#" @click.prevent="downloadContractTemplate" class="contract-link">
                        <i class="pi pi-download"></i>
                        Download Contract Template
                    </a>
                    <p>As you review the contract, you'll see various blanks to fill in. Complete these fields and make
                        any
                        necessary edits to create a draft you can share with the customer.</p>
                </div>

                <div class="contract-step">
                    <h5>Step 2: Reach Out to the Customer</h5>
                    <p>Use the contact information below to introduce yourself and share the draft with them to begin
                        collaboration.</p>
                    <div class="customer-info">
                        <div class="info-item">
                            <strong>Company Name:</strong> <span>{{ opportunityDetails?.company_name || 'N/A'
                                }}</span>
                        </div>
                        <div class="info-item">
                            <strong>Company URL:</strong> <span>{{ opportunityDetails?.company_website_url || 'N/A'
                                }}</span>
                        </div>
                        <div class="info-item">
                            <strong>Your Contact:</strong> <span>{{ opportunityDetails?.first_name && opportunityDetails?.last_name ? `${opportunityDetails?.first_name} ${opportunityDetails?.last_name}` : 'N/A'
                                }}</span>
                        </div>
                        <div class="info-item">
                            <strong>Email:</strong> <span>{{ opportunityDetails?.email || 'N/A'
                                }}</span>
                        </div>
                        <div class="info-item">
                            <strong>Phone:</strong> <span>{{ opportunityDetails?.phone_number || 'N/A'
                                }}</span>
                        </div>
                    </div>
                </div>

                <div class="contract-step">
                    <h5>Step 3: Complete the Contract Together</h5>
                    <p>Work with your customer to revise the draft as needed until you're both satisfied. You can use
                        Word's
                        track changes and commenting tools to collaborate.</p>
                </div>

                <div class="contract-step">
                    <h5>Step 4: Upload the Final Word Document</h5>
                    <p>Once you've finalized the draft together, upload the final version using the unique link provided
                        for
                        this RFP. The system will:</p>
                    <ul>
                        <li>Incorporate ArenaCX's standard marketplace Terms</li>
                        <li>Append the signature page</li>
                        <li>Generate a signable document</li>
                        <li>Email both parties an invitation to sign</li>
                    </ul>
                    <a :href="contractUploadUrl" target="_blank" class="contract-link">
                        <i class="pi pi-upload"></i>
                        Click to upload your final draft here ...
                    </a>
                    <p class="upload-note"><strong>Note:</strong> Each project has a unique URL. Don't reuse URLs from
                        previous projects!</p>
                </div>

                <div class="contract-step">
                    <h5>Step 5: Execute the Contract</h5>
                    <p>The system will send email invitations for electronic signature allowing both parties to sign the
                        document.</p>
                </div>
            </div>
        </div>
    </div>

    <div v-else>
        <div class="message-btn-container">
            <Button label="Message" class="p-button-primary" @click="openMessageSidebar">
                <img src="@/assets/message.svg" alt="Message" class="message-icon" />
                Message
            </Button>
        </div>

       

        <div class="opportunity-container">

             <!-- Instructions after participating -->
            <div v-if="opportunityDetails?.vendor_status_id === 9" class="rfp-instructions">
                <p>In order to participate in this RFP, provide the requested information. Previously provided information has been pre-filled for your convenience, but you may update it as needed. When finished, click the <b>Submit Response</b> button by the due date listed below.</p>
                <p>If you need additional information from the client in order to complete the response, click <b>Message</b> to send them an email or contact ArenaCX support at Support@ArenaCX.com.</p>
            </div>
            <div v-else-if="opportunityDetails?.vendor_status_id === 10">
                <div class="rfp-instructions">
                    <p>You have submitted a response, but until the response period closes, you may modify or withdraw your response. Responses are not considered final until the response period expires.</p>
                </div>
            </div>
            <div v-else class="rfp-instructions">
                <p>You've been invited to participate in this RFP. Review the client information and consider whether you wish to submit a bid. If you would like to bid, click <b>Participate</b>; otherwise, click <b>Decline</b>.</p>
                <p>If you need additional information from the client in order to decide, click Message to send them an email or contact ArenaCX support at Support@ArenaCX.com.</p>
            </div>
            <!-- Header Section -->
            <div class="header-section">
                <div style="width: 80%;">
                    <div class="header-title">
                        <Skeleton v-if="loading" height="1.5rem" width="70%"></Skeleton>
                        <span v-else class="rfp-title">{{ opportunityDetails?.prokuria_rfp_name }}</span>
                    </div>
                    <div class="header-meta">
                        <Skeleton v-if="loading" height="1.5rem" width="8rem"></Skeleton>
                        <span v-else class="opportunity-id-badge">Opportunity ID {{ opportunityDetails?.rfp_id }}</span>
                        <Skeleton v-if="loading" height="1.5rem" width="8rem"></Skeleton>
                        <span v-else class="timer-badge" :class="{ 'ended': isRfpEnded }">
                            {{ isRfpEnded ? 'RFP has ended' : (countdown ? `Response period closes in ${countdown.days}d ${countdown.hours}h ${countdown.minutes}m ${countdown.seconds}s` : 'RFP has ended') }}
                        </span>
                        <Skeleton v-if="loading" height="1.5rem" width="8rem"></Skeleton>
                        <span v-else class="date-badge">End date: {{ formatDate(opportunityDetails?.end_date) }}</span>
                    </div>

                </div>
                <div>
                    <div v-if="!showPricingTable">
                        <div v-if="loading" class="action-buttons">
                            <Skeleton height="2rem" width="100px" class="mb-2"></Skeleton>
                            <Skeleton height="2rem" width="100px" class="mb-2"></Skeleton>
                        </div>
                        <div v-else class="action-buttons">
                            <template v-if="opportunityDetails?.vendor_status_id === 8 && !isRfpEnded">
                                <Button label="Decline" class="p-button-outlined p-button-secondary"
                                    @click="handleDecline" />
                                <Button label="Participate" class="p-button-primary"
                                    :loading="participating" :disabled="participating" @click="onParticipate" />
                            </template>
                            <template v-else-if="opportunityDetails?.vendor_status_id === 17">
                                <div class="status-message declined">
                                    <i class="pi pi-times-circle"></i>
                                    <span>RFP has been declined</span>
                                </div>
                            </template>
                            <template v-else>
                                <Button label="Next" class="p-button-primary" @click="togglePricingTable" />
                            </template>
                        </div>
                    </div>
                    <div v-else>
                        <div class="action-buttons">
                            <template v-if="showRetractButton">
                                <Button v-if="!isRfpEnded" label="Retract" class="p-button-danger"
                                    @click="handleRetractResponse" :loading="retracting" />
                                <Button label="Download" icon="pi pi-download" class="p-button-success download-excel-btn"
                                    @click="exportResponsesToExcel" />
                            </template>
                            <template v-else-if="!isRfpEnded">
                                <Button :label="'Save Draft'" class="p-button-primary"
                                    :loading="savingDraft" :disabled="savingDraft" @click="handleSaveAsDraft" />
                                <Button label="Submit Response" :disabled="!isLastTab || submitting"
                                    :loading="submitting" class="p-button-primary"
                                    @click="handleNext" />
                            </template>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Only show these sections if not showing pricing table -->
            <template v-if="!showPricingTable">
                <Card class="intro-section">
                    <template #title>
                        <div class="intro-title-section">
                            <div>
                                <h3 class="intro-title">Intro</h3>
                                <!-- <span class="intro-subtitle">Request for Proposal (RFP) for Outsourcing Services</span> -->
                            </div>
                            <div class="date-badge-container">
                                <Skeleton v-if="loading" height="1.5rem" width="8rem"></Skeleton>
                                <span v-else class="date-badge">Start date: {{
                                    formatDate(opportunityDetails?.published_at) }}</span>
                                <Skeleton v-if="loading" height="1.5rem" width="8rem"></Skeleton>
                                <span v-else class="date-badge">End date:
                                    {{ formatDate(opportunityDetails?.end_date) }}</span>
                            </div>
                        </div>
                    </template>
                    <template #content>
                        <div v-if="loading" class="intro-content">
                            <div class="skeleton-section">
                                <Skeleton height="2rem" width="70%" class="mb-2"></Skeleton>
                                <Skeleton height="1rem" width="90%" class="mb-2"></Skeleton>
                                <Skeleton height="1rem" width="85%" class="mb-2"></Skeleton>
                                <Skeleton height="1rem" width="80%" class="mb-2"></Skeleton>
                            </div>
                            <div class="skeleton-section">
                                <Skeleton height="2rem" width="60%" class="mb-2"></Skeleton>
                                <Skeleton height="1rem" width="95%" class="mb-2"></Skeleton>
                                <Skeleton height="1rem" width="90%" class="mb-2"></Skeleton>
                                <Skeleton height="1rem" width="85%" class="mb-2"></Skeleton>
                            </div>
                            <div class="skeleton-section">
                                <Skeleton height="2rem" width="65%" class="mb-2"></Skeleton>
                                <Skeleton height="1rem" width="88%" class="mb-2"></Skeleton>
                                <Skeleton height="1rem" width="92%" class="mb-2"></Skeleton>
                            </div>
                            <div class="skeleton-section">
                                <Skeleton height="2rem" width="55%" class="mb-2"></Skeleton>
                                <div class="skeleton-list">
                                    <Skeleton height="1rem" width="80%" class="mb-2"></Skeleton>
                                    <Skeleton height="1rem" width="75%" class="mb-2"></Skeleton>
                                    <Skeleton height="1rem" width="85%" class="mb-2"></Skeleton>
                                </div>
                            </div>
                        </div>
                        <div v-else class="intro-content" v-html="opportunityDetails?.description"></div>
                    </template>
                </Card>

                <!-- Links Section -->
                <Card class="links-section">
                    <template #title>
                        Links
                    </template>
                    <template #content>
                        <div v-if="loading" class="links-list">
                            <Skeleton height="1.5rem" width="100%" class="mb-2"></Skeleton>
                            <Skeleton height="1.5rem" width="100%" class="mb-2"></Skeleton>
                        </div>
                        <ul v-else class="links-list">
                            <li v-for="link in opportunityDetails?.links" :key="link.linkUrl">
                                <a :href="link.linkUrl" target="_blank">{{ link.linkDescription }}</a>
                            </li>
                            <li v-if="!opportunityDetails?.links?.length" class="no-data">No links available</li>
                        </ul>
                    </template>
                </Card>

                <!-- Attachments Section -->
                <Card class="attachments-section">
                    <template #title>
                        Attachments
                    </template>
                    <template #content>
                        <div v-if="loading" class="attachments-list">
                            <Skeleton height="1.5rem" width="100%" class="mb-2"></Skeleton>
                            <Skeleton height="1.5rem" width="100%" class="mb-2"></Skeleton>
                        </div>
                        <div v-else class="attachments-list">
                            <div v-for="attachment in opportunityDetails?.attachments" :key="attachment.fileUrl"
                                class="attachment-item">
                                <a href="#" @click.prevent="downloadAttachment(attachment)" class="file-name">{{
                                    attachment.fileName }}</a>
                            </div>
                            <div v-if="!opportunityDetails?.attachments?.length" class="no-data">No attachments
                                available</div>
                        </div>
                    </template>
                </Card>

                <!-- Action Buttons -->
                <!-- <Card>
                <template #content>
                    <div v-if="loading" class="action-buttons">
                        <Skeleton height="2rem" width="100px" class="mb-2"></Skeleton>
                        <Skeleton height="2rem" width="100px" class="mb-2"></Skeleton>
                    </div>
                    <div v-else class="action-buttons">
                        <template v-if="opportunityDetails?.vendor_status_id === 8 && !isRfpEnded">
                            <Button label="Decline" class="p-button-outlined p-button-secondary" @click="handleDecline" />
                            <Button label="Participate" class="p-button-primary" @click="onParticipate" />
                        </template>
                        <template v-else-if="opportunityDetails?.vendor_status_id === 17">
                            <div class="status-message declined">
                                <i class="pi pi-times-circle"></i>
                                <span>RFP has been declined</span>
                            </div>
                        </template>
                        <template v-else>
                            <Button label="Next" class="p-button-primary" @click="togglePricingTable" />
                        </template>
                    </div>
                </template>
            </Card> -->
            </template>


            <!-- Pricing Table Section -->
            <template v-else>
                <div class="pricing-tables-btns-intro">
                    <div class="pricing-tables-toggle-container">
                        <Button label="Request for Proposal" class="pricing-tables-toggle-btn"
                            :class="{ 'active': active === 0 }" @click="active = 0" />
                        <Button v-for="(table, index) in opportunityDetails?.pricing_data" :key="table.table_name"
                            @click="active = index + 1" :class="{ 'active': active === index + 1 }"
                            :label="table.table_name" class="pricing-tables-toggle-btn" />
                        <Button v-for="(group, groupName, index) in groupedQuestions" :key="groupName"
                            @click="active = (opportunityDetails?.pricing_data?.length || 0) + index + 1"
                            :class="{ 'active': active === (opportunityDetails?.pricing_data?.length || 0) + index + 1 }"
                            :label="groupName" class="pricing-tables-toggle-btn" />
                    </div>

                    <div class="pricing-tables-intro">
                        <Button v-if="active > 0" label="Previous" class="p-button-outlined p-button-secondary mr-2"
                            @click="handlePrevious" />
                        <Button v-if="!isLastTab" label="Next" class="p-button-primary" @click="handleNext" />
                    </div>
                </div>

                <TabView class="pricing-tables-tabview" v-model:activeIndex="active">
                    <!-- Request for Proposal Tab (Intro Content) -->
                    <TabPanel>
                        <Card class="intro-section">
                            <template #title>
                                <div class="intro-title-section">
                                    <div>
                                        <h3 class="intro-title">Intro</h3>
                                        <!-- <span class="intro-subtitle">Request for Proposal (RFP) for Outsourcing Services</span> -->
                                    </div>
                                    <div class="date-badge-container">
                                        <Skeleton v-if="loading" height="1.5rem" width="8rem"></Skeleton>
                                        <span v-else class="date-badge">Start date: {{
                                            formatDate(opportunityDetails?.published_at) }}</span>
                                        <Skeleton v-if="loading" height="1.5rem" width="8rem"></Skeleton>
                                        <span v-else class="date-badge">End date:
                                            {{ formatDate(opportunityDetails?.end_date) }}</span>
                                    </div>
                                </div>
                            </template>
                            <template #content>
                                <div v-if="loading" class="intro-content">
                                    <div class="skeleton-section">
                                        <Skeleton height="2rem" width="70%" class="mb-2"></Skeleton>
                                        <Skeleton height="1rem" width="90%" class="mb-2"></Skeleton>
                                        <Skeleton height="1rem" width="85%" class="mb-2"></Skeleton>
                                        <Skeleton height="1rem" width="80%" class="mb-2"></Skeleton>
                                    </div>
                                    <div class="skeleton-section">
                                        <Skeleton height="2rem" width="60%" class="mb-2"></Skeleton>
                                        <Skeleton height="1rem" width="95%" class="mb-2"></Skeleton>
                                        <Skeleton height="1rem" width="90%" class="mb-2"></Skeleton>
                                        <Skeleton height="1rem" width="85%" class="mb-2"></Skeleton>
                                    </div>
                                    <div class="skeleton-section">
                                        <Skeleton height="2rem" width="65%" class="mb-2"></Skeleton>
                                        <Skeleton height="1rem" width="88%" class="mb-2"></Skeleton>
                                        <Skeleton height="1rem" width="92%" class="mb-2"></Skeleton>
                                    </div>
                                    <div class="skeleton-section">
                                        <Skeleton height="2rem" width="55%" class="mb-2"></Skeleton>
                                        <div class="skeleton-list">
                                            <Skeleton height="1rem" width="80%" class="mb-2"></Skeleton>
                                            <Skeleton height="1rem" width="75%" class="mb-2"></Skeleton>
                                            <Skeleton height="1rem" width="85%" class="mb-2"></Skeleton>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="intro-content" v-html="opportunityDetails?.description"></div>
                            </template>
                        </Card>

                        <!-- Links Section -->
                        <Card class="links-section">
                            <template #title>
                                Links
                            </template>
                            <template #content>
                                <div v-if="loading" class="links-list">
                                    <Skeleton height="1.5rem" width="100%" class="mb-2"></Skeleton>
                                    <Skeleton height="1.5rem" width="100%" class="mb-2"></Skeleton>
                                </div>
                                <ul v-else class="links-list">
                                    <li v-for="link in opportunityDetails?.links" :key="link.linkUrl">
                                        <a :href="link.linkUrl" target="_blank">{{ link.linkDescription }}</a>
                                    </li>
                                    <li v-if="!opportunityDetails?.links?.length" class="no-data">No links available
                                    </li>
                                </ul>
                            </template>
                        </Card>

                        <!-- Attachments Section -->
                        <Card class="attachments-section">
                            <template #title>
                                Attachments
                            </template>
                            <template #content>
                                <div v-if="loading" class="attachments-list">
                                    <Skeleton height="1.5rem" width="100%" class="mb-2"></Skeleton>
                                    <Skeleton height="1.5rem" width="100%" class="mb-2"></Skeleton>
                                </div>
                                <div v-else class="attachments-list">
                                    <div v-for="attachment in opportunityDetails?.attachments" :key="attachment.fileUrl"
                                        class="attachment-item">
                                        <a href="#" @click.prevent="downloadAttachment(attachment)" class="file-name">{{
                                            attachment.fileName }}</a>
                                    </div>
                                    <div v-if="!opportunityDetails?.attachments?.length" class="no-data">No attachments
                                        available</div>
                                </div>
                            </template>
                        </Card>
                    </TabPanel>
                    <!-- Pricing Tables Tabs -->
                    <TabPanel v-for="(table, tableIndex) in opportunityDetails?.pricing_data" :key="table.table_name">
                        <div class="pricing-table-section">
                            <div class="pricing-table-header">
                                <p class="pricing-table-section-title">{{ table.table_name }}</p>
                            </div>

                            <!-- Nested tables navigation -->
                            <div v-if="table.table_data.allowNestedTables" class="nested-tables-nav">
                                <Button v-if="!table.nestedTables || table.nestedTables.length === 0"
                                    @click="activeNestedTable[tableIndex] = undefined"
                                    :class="{ 'active': activeNestedTable[tableIndex] === undefined }"
                                    :label="table.table_name" class="nested-table-btn" />
                                <div v-for="(nestedTable, nestedIndex) in table.nestedTables"
                                    :key="nestedTable.table_name" class="nested-table-item">
                                    <div v-if="editingNestedTableName.tableIndex === tableIndex && editingNestedTableName.nestedIndex === nestedIndex"
                                        class="nested-table-edit-container">
                                        <InputText v-model="editingNestedTableName.newName"
                                            class="nested-table-edit-input"
                                            @keyup.enter="confirmEditNestedTableName(tableIndex, nestedIndex)"
                                            @keyup.esc="cancelEditNestedTableName" ref="nestedTableNameInput"
                                            :disabled="isInputDisabled" />
                                    </div>
                                    <Button v-else @click="activeNestedTable[tableIndex] = nestedIndex"
                                        :class="{ 'active': activeNestedTable[tableIndex] === nestedIndex }"
                                        :label="nestedTable.table_name" class="nested-table-btn"
                                        @dblclick="startEditNestedTableName(tableIndex, nestedIndex)" />
                                    <Button
                                        v-if="editingNestedTableName.tableIndex === tableIndex && editingNestedTableName.nestedIndex === nestedIndex"
                                        icon="pi pi-check" class="p-button-success p-button-text edit-confirm-btn"
                                        @click="confirmEditNestedTableName(tableIndex, nestedIndex)" />
                                    <Button
                                        v-if="editingNestedTableName.tableIndex === tableIndex && editingNestedTableName.nestedIndex === nestedIndex"
                                        icon="pi pi-times" class="p-button-danger p-button-text edit-cancel-btn"
                                        @click="cancelEditNestedTableName" />
                                </div>
                                <Button v-if="table.table_data.allowNestedTables" label="Add Location"
                                    :disabled="isRfpEnded" class="p-button-primary add-table-btn"
                                    @click="addNestedTable(tableIndex)" />
                            </div>

                            <!-- Table content -->
                            <div v-if="!table.table_data.allowNestedTables || (table.table_data.allowNestedTables && (!table.nestedTables || table.nestedTables.length === 0) && activeNestedTable[tableIndex] === undefined)"
                                class="pricing-table-section-content">
                                <DataTable :value="table.table_data.rows">
                                    <Column v-for="column in table.table_data.columns" :key="column.id"
                                        :field="column.id" :header="column.title">
                                        <template #body="slotProps">
                                            <div style="width: 200px;" v-if="column.input_source === 'vendor'">
                                                <!-- Dropdown -->
                                                <Dropdown v-if="column.input_type === 3"
                                                    v-model="slotProps.data.data[column.id]" :options="column.options"
                                                    optionLabel="option_value" optionValue="option_value"
                                                    :class="['pricing-table-input', { 'mandatory-field': column.isMandatory && !slotProps.data.data[column.id] }]"
                                                    :required="column.isMandatory" :disabled="isInputDisabled"
                                                    style="width: 170px;" placeholder="Select an option" />
                                                <!-- Text input for all other types -->
                                                <InputText style="width: 170px;" v-else
                                                    v-model="slotProps.data.data[column.id]"
                                                    :class="['pricing-table-input', { 'mandatory-field': column.isMandatory && !slotProps.data.data[column.id] }]"
                                                    :placeholder="column.title" :required="column.isMandatory"
                                                    :disabled="isInputDisabled" />
                                            </div>
                                            <div style="width: 200px;" v-else>
                                                {{ slotProps.data.data[column.id] }}
                                            </div>
                                        </template>
                                    </Column>
                                </DataTable>
                            </div>
                            <div v-else-if="table.table_data.allowNestedTables && table.nestedTables && table.nestedTables.length > 0"
                                class="pricing-table-section-content">
                                <div class="nested-table-header">
                                    <Button icon="pi pi-trash" class="p-button-danger p-button-text"
                                        @click="removeNestedTable(tableIndex, activeNestedTable[tableIndex])"
                                        :disabled="isInputDisabled || activeNestedTable[tableIndex] === undefined" />
                                </div>
                                <DataTable
                                    v-if="activeNestedTable[tableIndex] !== undefined && table.nestedTables && table.nestedTables[activeNestedTable[tableIndex]]"
                                    :value="table.nestedTables[activeNestedTable[tableIndex]].table_data.rows">
                                    <Column
                                        v-for="column in table.nestedTables[activeNestedTable[tableIndex]].table_data.columns"
                                        :key="column.id" :field="column.id" :header="column.title">
                                        <template #body="slotProps">
                                            <div style="width: 200px;" v-if="column.input_source === 'vendor'">
                                                <!-- Dropdown -->
                                                <Dropdown v-if="column.input_type === 3"
                                                    v-model="slotProps.data.data[column.id]" :options="column.options"
                                                    optionLabel="option_value" optionValue="option_value"
                                                    :class="['pricing-table-input', { 'mandatory-field': column.isMandatory && !slotProps.data.data[column.id] }]"
                                                    :required="column.isMandatory" :disabled="isInputDisabled"
                                                    style="width: 170px;" placeholder="Select an option" />
                                                <!-- Text input for all other types -->
                                                <InputText style="width: 170px;" v-else
                                                    v-model="slotProps.data.data[column.id]"
                                                    :class="['pricing-table-input', { 'mandatory-field': column.isMandatory && !slotProps.data.data[column.id] }]"
                                                    :placeholder="column.title" :required="column.isMandatory"
                                                    :disabled="isInputDisabled" />
                                            </div>
                                            <div style="width: 200px;" v-else>
                                                {{ slotProps.data.data[column.id] }}
                                            </div>
                                        </template>
                                    </Column>
                                </DataTable>
                                <div v-else class="no-nested-table">
                                    <p>No nested table selected or table not found.</p>
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <!-- Question Group Tabs -->
                    <TabPanel v-for="(group, groupName) in groupedQuestions" :key="groupName">
                        <div class="pricing-table-section">
                            <p class="pricing-table-section-title">{{ groupName }}</p>
                            <div class="company-profile-form">
                                <div v-for="question in group" :key="question.id" class="company-profile-question"
                                    :data-question-id="question.id">
                                    <label class="company-profile-label">
                                        {{ question.title }}
                                    </label>
                                    <!-- Engineering Workforce Profile: render the structured
                                         table component instead of a generic textarea so the
                                         vendor sees the same row-label + dropdown grid they
                                         filled in their answer bank. Schema + prefill loaded
                                         in loadEwpSchemasAndPrefill(). Falls through to the
                                         normal idQuestionType dispatch when the schema fetch
                                         hasn't resolved yet or the question is not EWP. -->
                                    <StructuredTableComponent
                                        v-if="isEwpQuestion(question) && getEwpFieldItem(question)"
                                        :item="getEwpFieldItem(question)"
                                        :label="''"
                                        :modelValue="parseEwpAnswer(question.response.answer)"
                                        :validation_rules="getEwpFieldItem(question).validation_rules || {}"
                                        :required="!!question.isMandatory"
                                        :disableEdit="isInputDisabled"
                                        @update:modelValue="(v) => setEwpAnswer(question, v)"
                                    />
                                    <!-- Long text -->
                                    <Textarea v-else-if="question.idQuestionType === 1" v-model="question.response.answer"
                                        :placeholder="question.placeholder || 'Enter your answer'"
                                        :class="['company-profile-input', { 'mandatory-field': question.isMandatory && !question.response.answer }]"
                                        autoResize rows="3" :disabled="isInputDisabled" />
                                    <!-- Single Choice (Dropdown) -->
                                    <Dropdown v-else-if="question.idQuestionType === 2"
                                        v-model="question.response.answer"
                                        :placeholder="question.placeholder || 'Select'" :options="question.options"
                                        optionLabel="optionValue" optionValue="id"
                                        :class="['company-profile-input', { 'mandatory-field': question.isMandatory && !question.response.answer }]"
                                        :disabled="isInputDisabled" />
                                    <!-- Multiple Choice (MultiSelect) -->
                                    <MultiSelect v-else-if="question.idQuestionType === 3"
                                        v-model="question.response.answer"
                                        :placeholder="question.placeholder || 'Select'" :options="question.options"
                                        optionLabel="optionValue" optionValue="id"
                                        :class="['company-profile-input', { 'mandatory-field': question.isMandatory && (!question.response.answer || question.response.answer.length === 0) }]"
                                        :disabled="isInputDisabled" />
                                    <!-- Short text -->
                                    <InputText v-else-if="question.idQuestionType === 4"
                                        v-model="question.response.answer" 
                                        :placeholder="question.placeholder || 'Enter your answer'"
                                        :class="['company-profile-input', { 'mandatory-field': question.isMandatory && !question.response.answer }]"
                                        :disabled="isInputDisabled" />
                                    <!-- Type 5 has no main input; file block shown below for type 5 or canUploadFiles -->
                                    <template v-else-if="question.idQuestionType === 5"></template>
                                    <!-- Dropdown single choice -->
                                    <Dropdown v-else-if="question.idQuestionType === 6"
                                        v-model="question.response.answer"
                                        :placeholder="question.placeholder || 'Select'" :options="question.options"
                                        optionLabel="optionValue" optionValue="id"
                                        :class="['company-profile-input', { 'mandatory-field': question.isMandatory && !question.response.answer }]"
                                        :disabled="isInputDisabled" />
                                    <!-- Dropdown multiple choice -->
                                    <MultiSelect v-else-if="question.idQuestionType === 7"
                                        v-model="question.response.answer"
                                        :placeholder="question.placeholder || 'Select'" :options="question.options"
                                        optionLabel="optionValue" optionValue="id"
                                        :class="['company-profile-input', { 'mandatory-field': question.isMandatory && (!question.response.answer || question.response.answer.length === 0) }]"
                                        :disabled="isInputDisabled" />
                                    <!-- Number -->
                                    <InputNumber v-else-if="question.idQuestionType === 8"
                                        v-model="question.response.answer"
                                        :placeholder="question.placeholder || 'Enter your answer'"
                                        :class="['company-profile-input', { 'mandatory-field': question.isMandatory && !question.response.answer }]"
                                        :disabled="isInputDisabled"
                                        :useGrouping="false" />
                                    <!-- Date -->
                                    <Calendar v-else-if="question.idQuestionType === 9"
                                        v-model="question.response.answer"
                                        :class="['company-profile-input', { 'mandatory-field': question.isMandatory && !question.response.answer }]"
                                        showIcon :disabled="isInputDisabled" style="width: 150px;" />
                                    <!-- Default: Text input -->
                                    <InputText v-else v-model="question.response.answer"
                                        :placeholder="question.placeholder || 'Enter your answer'"
                                        :class="['company-profile-input', { 'mandatory-field': question.isMandatory && !question.response.answer }]"
                                        :disabled="isInputDisabled" />
                                    <!-- File upload: show for type 5 (file-only), canUploadFiles, or when question has attached file (e.g. after retract restore) -->
                                    <div v-if="question.idQuestionType === 5 || question.canUploadFiles || hasAttachedFile(question)" class="file-upload-container">
                                        <div v-if="(question.idQuestionType === 5 || question.canUploadFiles) && !hasAttachedFile(question)" class="file-upload-wrapper">
                                            <input :key="(question.fileInputKey || question.id) + '_file'"
                                                :ref="`fileInput_${question.id}`" type="file"
                                                :class="['file-upload-input', { 'mandatory-field': question.idQuestionType === 5 && question.isMandatory && !isDocumentsArray(question.response.documents) }]"
                                                @change="onFileChange($event, question)"
                                                :disabled="uploadingFileId === question.id || isInputDisabled" />
                                            <div class="file-upload-label">
                                                <i class="pi pi-upload"></i>
                                                <span>{{ uploadingFileId === question.id ? 'Uploading...' : 'Choose File' }}</span>
                                            </div>
                                        </div>
                                        <div v-if="uploadingFileId === question.id" class="upload-progress">
                                            <ProgressBar mode="indeterminate" />
                                        </div>
                                        <div v-if="hasAttachedFile(question) && getAttachedDocument(question)"
                                            class="file-name-container file-name-container--single-line">
                                            <span class="file-attached-hint">1 file attached.</span>
                                            <div class="file-name-cell"
                                                @click="downloadFileFromQuestion(getAttachedDocument(question))"
                                                :title="getAttachedDocument(question).name">
                                                <i class="pi pi-file file-name-icon"></i>
                                                <span class="file-name">{{ getAttachedDocument(question).name }}</span>
                                            </div>
                                            <div class="file-actions">
                                                <Button icon="pi pi-eye" v-if="getAttachedDocument(question).key"
                                                    class="p-button-text p-button-rounded view-file-btn"
                                                    v-tooltip.top="'View'"
                                                    @click="viewFile(getAttachedDocument(question))" :disabled="isInputDisabled" />
                                                <Button icon="pi pi-times"
                                                    class="p-button-text p-button-rounded p-button-danger remove-file-btn"
                                                    v-tooltip.top="'Remove'"
                                                    @click="removeFile(question)" :disabled="isInputDisabled" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                </TabView>

                <!-- <Card>
                <template #content>
                    <div class="action-buttons">
                        <template v-if="!isRfpEnded">
                            <template v-if="showRetractButton">
                                <Button 
                                    label="Retract Response" 
                                    class="p-button-danger" 
                                    @click="handleRetractResponse" 
                                    :loading="retracting" />
                            </template>
                            <template v-else>
                                <Button 
                                    :label="'Save as Draft'" 
                                    class="p-button-primary"
                                    @click="handleSaveAsDraft" />
                                <Button 
                                    :label="isLastTab ? 'Submit Response' : 'Next'" 
                                    class="p-button-primary"
                                    @click="handleNext" />
                            </template>
                        </template>
                    </div>
                </template>
            </Card> -->
            </template>

            <!-- Terms and Conditions Dialog (unchanged) -->
            <Dialog :draggable="false" v-model:visible="showTermsDialog" :modal="true" :closable="false" :style="{ width: '50vw' }"
                header="Terms and conditions">
                <div style="max-height: 50vh; overflow-y: auto;">
                    <p>
                        By proceeding with receiving information in connection with this request for pricing, I
                        understand
                        that any
                        information received is subject to the Marketplace Partner Agreement signed between ArenaCX and
                        the
                        marketplace partner on behalf of whom I work or am engaged (the "MPPA"). Accordingly, I
                        understand
                        that any
                        potential or prospective customer or marketplace member revealed or provided as part of this
                        request
                        for
                        pricing represents ArenaCX notifying me that this potential or prospective customer or
                        marketplace
                        member
                        shall be considered a Qualified Sales Opportunity (QSO) and such information (including the name
                        of
                        such
                        potential or prospective customer or marketplace member) shall (i) constitute Confidential
                        Information under
                        the MPPA and (ii) shall be subject in all respects to the terms and conditions of the MPPA,
                        including,
                        without limitation, the non-circumvention provisions in Section 2 of the MPPA.
                    </p>
                    <div class="p-field-checkbox">
                        <Checkbox v-model="termsAccepted" :binary="true" inputId="termsCheckbox" />
                        <label for="termsCheckbox">I agree and accept the above terms and condition of use</label>
                    </div>
                </div>
                <template #footer>
                    <Button label="Continue" :loading="accepting" :disabled="!termsAccepted || accepting"
                        @click="onTermsAccepted" />
                </template>
            </Dialog>

            <!-- Add Retract Confirmation Dialog -->
            <Dialog :draggable="false" v-model:visible="showRetractDialog" :modal="true" :closable="false" :style="{ width: '30vw' }"
                header="Confirm Retraction">
                <div class="retract-confirmation">
                    <p>Are you sure you want to retract your response? This action cannot be undone.</p>
                </div>
                <template #footer>
                    <Button label="Cancel" class="p-button-text" @click="showRetractDialog = false" />
                    <Button label="Retract" class="p-button-danger" @click="confirmRetract" :loading="retracting" />
                </template>
            </Dialog>

            <!-- Add Decline Confirmation Dialog -->
            <Dialog :draggable="false" v-model:visible="showDeclineDialog" :modal="true" :closable="false" :style="{ width: '30vw' }"
                header="Confirm Decline">
                <div class="decline-confirmation">
                    <p>Are you sure you want to decline this opportunity? This action cannot be undone.</p>
                </div>
                <template #footer>
                    <Button label="Cancel" class="p-button-text" @click="showDeclineDialog = false" />
                    <Button label="Decline" class="p-button-danger" @click="confirmDecline" :loading="declining" />
                </template>
            </Dialog>
        </div>
    </div>
</template>

<script>
import Dialog from 'primevue/dialog';
import Checkbox from 'primevue/checkbox';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import { useRoute } from 'vue-router';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Toast from 'primevue/toast';
import ProgressBar from 'primevue/progressbar';
import Sidebar from 'primevue/sidebar';
import Messaging from '@/components/partnerOpportunity/Messaging.vue';
import PartnerOpportunityService from '../service/PartnerOpportunityService';
import { getIsPartner, getAccountId } from '../service/common';
import StructuredTableComponent from '../components/answerBank/StructuredTableComponent.vue';
import { getApi } from '../service/common/apis';
import moment from 'moment';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';

// Engineering Workforce Profile question titles. Stable identifiers
// stamped by the RFP template-block helper -- the four titles never
// change once an EWP section is added to a template. Used to recognize
// the questions in the per-RFP response payload so we can swap the
// generic textarea renderer for the StructuredTableComponent that
// vendors are used to from their answer bank profile.
const EWP_TITLES = Object.freeze({
    'role distribution': 'engineering_workforce_profile__role_distribution',
    'seniority profile': 'engineering_workforce_profile__seniority_profile',
    'ai proficiency': 'engineering_workforce_profile__ai_proficiency',
    'global delivery footprint': 'engineering_workforce_profile__global_delivery_footprint',
});
// Software Engineering question_set is identified by its full_name (stable
// across all envs since the seed). Resolving by id was brittle -- a new
// env or a re-seed could pick a different sequence-issued id. Looked up
// once at runtime via /api/v2/question-set/list and cached for the
// session in this module-level holder.
const SE_QUESTION_SET_FULL_NAME = 'Talent:Software Engineering';
let _cachedSeQsId = null;
async function getSeQsId(answerBankBase) {
    if (_cachedSeQsId != null) return _cachedSeQsId;
    const res = await getApi('v2/question-set/list', answerBankBase);
    const list = res?.data?.data || res?.data || [];
    const entry = (Array.isArray(list) ? list : []).find(
        (qs) => qs?.full_name === SE_QUESTION_SET_FULL_NAME
    );
    if (!entry?.id) {
        throw new Error(
            `Could not resolve question_set id for full_name "${SE_QUESTION_SET_FULL_NAME}".`
        );
    }
    _cachedSeQsId = entry.id;
    return _cachedSeQsId;
}

// Display labels for the EWP row keys. Used by the per-vendor Download
// (exportResponsesToExcel) so the spreadsheet shows "Software engineering:
// 1-25%" instead of {"software_engineering":"1-25%",...}. Mirrors the
// seed labels in the AnswerBank.
const EWP_ROW_LABELS = Object.freeze({
    engineering_workforce_profile__role_distribution: {
        software_engineering: 'Software engineering',
        qa_test_engineering: 'QA / test engineering',
        devops_platform_infra: 'DevOps / platform / infrastructure',
        data_ai_engineering: 'Data & AI engineering',
        security_engineering: 'Security engineering',
        architecture: 'Architecture',
        engineering_mgmt_overhead: 'Engineering management & overhead',
    },
    engineering_workforce_profile__seniority_profile: {
        junior: 'Junior',
        mid_level: 'Mid-level',
        senior: 'Senior',
        staff_principal: 'Staff / Principal',
    },
    engineering_workforce_profile__ai_proficiency: {
        ai_assisted: 'AI-assisted',
        ai_augmented: 'AI-augmented',
        ai_specialist: 'AI specialist',
    },
});

// Turn the JSON-string answer for an EWP question into a readable
// multi-line string for the per-vendor download. Returns null when
// `question` is not EWP so the caller falls through to its default path.
function formatEwpAnswerForDownload(question) {
    const titleLc = typeof question?.title === 'string'
        ? question.title.trim().toLowerCase()
        : '';
    const slug = EWP_TITLES[titleLc];
    if (!slug) return null;

    let raw = question?.response?.answer;
    if (raw == null || raw === '') return '';
    let parsed = raw;
    if (typeof parsed === 'string') {
        const s = parsed.trim();
        if (!s) return '';
        if (!s.startsWith('{') && !s.startsWith('[')) return s;
        try { parsed = JSON.parse(s); } catch (_e) { return ''; }
    }

    if (slug === 'engineering_workforce_profile__global_delivery_footprint') {
        if (!Array.isArray(parsed)) return '';
        return parsed
            .filter((row) => row && typeof row === 'object')
            .map((row) => {
                const country = row.country || '(country not specified)';
                const head = row.total_engineers != null && row.total_engineers !== ''
                    ? `${country} — ${row.total_engineers} engineers`
                    : country;
                const pcts = [];
                if (row.in_office_pct) pcts.push(`In-office ${row.in_office_pct}`);
                if (row.hybrid_pct) pcts.push(`Hybrid ${row.hybrid_pct}`);
                if (row.remote_pct) pcts.push(`Remote ${row.remote_pct}`);
                const tail = [];
                if (pcts.length) tail.push(pcts.join(' · '));
                if (row.employment_type) tail.push(row.employment_type);
                const langs = Array.isArray(row.languages) ? row.languages.filter(Boolean) : [];
                if (langs.length) tail.push(`Languages: ${langs.join(', ')}`);
                return tail.length ? `${head}\n  ${tail.join(' · ')}` : head;
            })
            .join('\n');
    }

    if (typeof parsed !== 'object' || Array.isArray(parsed)) return '';
    const labels = EWP_ROW_LABELS[slug] || {};
    return Object.entries(parsed)
        .filter(([, v]) => v != null && v !== '')
        .map(([k, v]) => `${labels[k] || k}: ${v}`)
        .join('\n');
}

export default {
    name: 'Opportunity',
    components: { Dialog, Checkbox, Button, InputText, TabView, TabPanel, Toast, ProgressBar, Sidebar, Messaging, StructuredTableComponent },
    data() {
        return {
            opportunityId: null,
            loading: true,
            showTermsDialog: false,
            termsAccepted: false,
            showPricingTable: false,
            active: 0,
            baseRateActive: 0,
            rfpEndTime: null,
            countdown: {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            },
            countdownInterval: null,
            partnerOpportunityService: new PartnerOpportunityService(),
            opportunityDetails: {
                questions: [] // Initialize with empty questions array
            },
            uploadingFileId: null, // Track which file is currently uploading
            retracting: false, // Track retract operation status
            // Guards against double-click on Submit Response / Save Draft. The submit
            // POST writes batch answers + pricing tables in one request; a second click
            // before the response arrives produces a byte-identical duplicate POST and
            // duplicates every rfp_responses + rfp_pricing row for the vendor.
            submitting: false,
            savingDraft: false,
            showRetractDialog: false, // Track retract confirmation dialog visibility
            declining: false, // Track decline operation status
            showDeclineDialog: false, // Track decline confirmation dialog visibility
            accepting: false, // Track terms-acceptance request in flight
            participating: false, // Track participate request in flight
            activeNestedTable: {}, // Track active nested table for each parent table
            showMessageSidebar: false,
            selectedMessage: null,
            isCreatingMessage: false,
            editingNestedTableName: {
                tableIndex: null,
                nestedIndex: null,
                newName: ''
            },
            isPartner: false,
            // EWP field schemas (one per slug) fetched from AnswerBank on
            // load and indexed by partner_field_info uuid. Used by the
            // StructuredTableComponent render branch in the question loop.
            ewpFieldBySlug: {},      // slug -> partner_field_info row (full schema)
            ewpSlugByFieldId: {},    // uuid -> slug (for question-to-schema lookup)
            ewpLoaded: false,
        };
    },
    async created() {
        const route = useRoute();
        this.opportunityId = route.query.id;
        console.log("Component created with ID:", this.opportunityId);
        this.isPartner = getIsPartner();
        await this.getTermsAndConditionsStatus();
        await this.getOpportunityDetails();
        this.loading = false;
        this.startCountdown();
    },
    mounted() {
        console.log("Component mounted");
        console.log("Initial opportunityDetails:", this.opportunityDetails);
        console.log("Initial groupedQuestions:", this.groupedQuestions);
    },
    beforeUnmount() {
        // Clean up the interval when component is destroyed
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }
    },
    methods: {
        // Helper method to safely check if documents is a valid array
        isDocumentsArray(documents) {
            return documents && Array.isArray(documents) && documents.length > 0;
        },

        /**
         * Parse documents from API (string, object, or array). Handles double-encoded JSON like:
         * "{\"{\\\"documentId\\\":\\\"...\\\",\\\"documentName\\\":\\\"...\\\"}\"}"
         * Returns normalized array [{ key, name, fileUrl }] or [].
         */
        parseDocumentsFromApi(value) {
            console.log('[parseDocumentsFromApi] input type:', typeof value, 'value:', value === null || value === undefined ? value : (typeof value === 'string' ? value.substring(0, 80) + '...' : value));
            if (value === undefined || value === null) return [];
            let docs = value;
            parseLoop: for (let i = 0; i < 5; i++) {
                console.log('[parseDocumentsFromApi] iteration', i, 'docs type:', typeof docs, Array.isArray(docs) ? 'length=' + docs.length : typeof docs === 'object' && docs ? 'keys=' + Object.keys(docs).join(',') : '');
                if (typeof docs === 'string') {
                    const trimmed = docs.trim();
                    if (!trimmed) return [];
                    try {
                        docs = JSON.parse(docs);
                        console.log('[parseDocumentsFromApi] parse ok, result type:', typeof docs, typeof docs === 'object' && docs && !Array.isArray(docs) ? 'keys=' + Object.keys(docs).join(',') : '');
                    } catch (e) {
                        console.log('[parseDocumentsFromApi] JSON.parse threw:', e.message);
                        // Regex fallback: match \"documentId\":\"value\" or "documentId":"value" (value = filename, may contain spaces)
                        let docId = '';
                        let docName = '';
                        const docIdMatch1 = docs.match(/documentId"\s*:\s*"([^"]*)"/);
                        const docIdMatch2 = docs.match(/documentId\\":\\"([^"]+)/);  // \"documentId\":\"value - capture value
                        const docNameMatch1 = docs.match(/documentName"\s*:\s*"([^"]*)"/);
                        const docNameMatch2 = docs.match(/documentName\\":\\"([^"]+)/);
                        docId = (docIdMatch1 && docIdMatch1[1]) || (docIdMatch2 && docIdMatch2[1]) || '';
                        docName = (docNameMatch1 && docNameMatch1[1]) || (docNameMatch2 && docNameMatch2[1]) || '';
                        console.log('[parseDocumentsFromApi] regex fallback docId:', docId, 'docName:', docName);
                        if (docId || docName) {
                            return [{ key: docId.trim(), name: docName.trim(), fileUrl: docId.trim() }];
                        }
                        // Try parsing inner JSON: string is {"{\"documentId\":\"...\",\"documentName\":\"...\"}"} - get innermost {...}
                        const innerObjMatch = docs.match(/\{[^{}]*"documentId"[^{}]*"documentName"[^{}]*\}|\{[^{}]*\\"documentId\\"[^{}]*\\"documentName\\"[^{}]*\}/);
                        if (innerObjMatch) {
                            const innerStr = innerObjMatch[0].replace(/\\"/g, '"');
                            try {
                                const parsed = JSON.parse(innerStr);
                                if (parsed && (parsed.documentId != null || parsed.documentName != null)) {
                                    console.log('[parseDocumentsFromApi] inner obj match parse ok:', parsed);
                                    return [{ key: parsed.documentId || '', name: parsed.documentName || '', fileUrl: parsed.documentId || '' }];
                                }
                            } catch (e2) {
                                // ignore
                            }
                        }
                        // Extract between first { and last }, replace \" with ", then find valid JSON (innermost object)
                        const firstBrace = docs.indexOf('{');
                        const lastBrace = docs.lastIndexOf('}');
                        if (firstBrace !== -1 && lastBrace > firstBrace) {
                            let innerStr = docs.substring(firstBrace, lastBrace + 1);
                            // If string is {"inner"} strip the outer quotes so we get {inner}
                            if (innerStr.startsWith('{"') && innerStr.endsWith('"}')) {
                                innerStr = innerStr.slice(2, -2).replace(/\\"/g, '"');
                            } else {
                                innerStr = innerStr.replace(/\\"/g, '"');
                            }
                            try {
                                const parsed = JSON.parse(innerStr);
                                if (parsed && (parsed.documentId != null || parsed.documentName != null)) {
                                    console.log('[parseDocumentsFromApi] inner parse ok:', parsed);
                                    return [{ key: parsed.documentId || '', name: parsed.documentName || '', fileUrl: parsed.documentId || '' }];
                                }
                            } catch (e2) {
                                // ignore
                            }
                        }
                        return [];
                    }
                } else if (typeof docs === 'object' && docs !== null) {
                    if (Array.isArray(docs)) {
                        return docs.map(d => (d && d.key != null ? d : { key: (d && d.documentId) || '', name: (d && d.documentName) || '', fileUrl: (d && d.documentId) || '' }));
                    }
                    if (docs.documentId != null || docs.documentName != null || docs.key != null) {
                        return [{ key: docs.documentId || docs.key || '', name: docs.documentName || docs.name || '', fileUrl: docs.documentId || docs.key || '' }];
                    }
                    // Object from malformed double-encode: e.g. { "{\"documentId": "image---...", "documentName": "image - ..." }
                    const keys = Object.keys(docs);
                    let docId = '';
                    let docName = '';
                    for (const k of keys) {
                        if (k === 'documentId' || k === 'documentName' || k === 'key' || k === 'name') {
                            if (k === 'documentId' || k === 'key') docId = docs[k];
                            if (k === 'documentName' || k === 'name') docName = docs[k];
                        } else if ((k.includes('documentId') || k.includes('documentKey')) && typeof docs[k] === 'string') {
                            docId = docs[k];
                        } else if (k.includes('documentName') && typeof docs[k] === 'string') {
                            docName = docs[k];
                        }
                    }
                    if (docId || docName) {
                        console.log('[parseDocumentsFromApi] extracted from object keys docId:', docId, 'docName:', docName);
                        return [{ key: docId || '', name: docName || '', fileUrl: docId || '' }];
                    }
                    if (keys.length === 1 && typeof docs[keys[0]] === 'string') {
                        docs = docs[keys[0]];
                        continue parseLoop;
                    }
                    for (const k of keys) {
                        if (typeof docs[k] === 'string' && (docs[k].includes('documentId') || docs[k].includes('documentName'))) {
                            docs = docs[k];
                            continue parseLoop;
                        }
                    }
                    return [];
                } else {
                    return [];
                }
            }
            const result = Array.isArray(docs)
                ? docs.map(d => (d && d.key != null ? d : { key: (d && d.documentId) || '', name: (d && d.documentName) || '', fileUrl: (d && d.documentId) || '' }))
                : (docs && (docs.documentId != null || docs.documentName != null) ? [{ key: docs.documentId || docs.key || '', name: docs.documentName || docs.name || '', fileUrl: docs.documentId || docs.key || '' }] : []);
            console.log('[parseDocumentsFromApi] returning', result.length, 'doc(s)', result);
            return result;
        },
        // True when this question has a file attached (array or single object from API)
        hasAttachedFile(question) {
            const docs = question.response?.documents;
            if (!docs) return false;
            if (Array.isArray(docs) && docs.length > 0) return true;
            if (typeof docs === 'object' && (docs.documentId || docs.documentName)) return true;
            return false;
        },
        // First attached document in a consistent shape { key, name } for display/actions
        getAttachedDocument(question) {
            const docs = question.response?.documents;
            if (!docs) return null;
            if (Array.isArray(docs) && docs.length > 0) return docs[0];
            if (typeof docs === 'object' && (docs.documentId || docs.documentName)) {
                return { key: docs.documentId, name: docs.documentName };
            }
            return null;
        },

        // Test method to verify documents handling
        testDocumentsHandling() {
            console.log('Testing documents handling:');
            console.log('Empty object {}:', this.isDocumentsArray({}));
            console.log('Empty array []:', this.isDocumentsArray([]));
            console.log('Array with items:', this.isDocumentsArray([{ name: 'test' }]));
            console.log('null:', this.isDocumentsArray(null));
            console.log('undefined:', this.isDocumentsArray(undefined));
        },

        // Format date
        formatDate(date) {
            if (!date) return "N/A";

            const localTime = moment(date).format('MMMM D, YYYY h:mm A');
            const gmtTime = moment.utc(date).format('h:mm A');

            // Get timezone offset and convert to abbreviation
            const offset = new Date().getTimezoneOffset();
            const timezoneAbbr = this.getTimezoneAbbr(offset);

            return `${localTime} ${timezoneAbbr} (${gmtTime} GMT)`;
        },

        getTimezoneAbbr(offset) {
            // Convert offset to hours (offset is in minutes, negative for ahead of GMT)
            const hours = -offset / 60;

            // Common timezone abbreviations
            const timezones = {
                '-12': 'IDLW', '-11': 'SST', '-10': 'HST', '-9': 'AKST', '-8': 'PST',
                '-7': 'MST', '-6': 'CST', '-5': 'EST', '-4': 'AST', '-3': 'BRT',
                '-2': 'GST', '-1': 'AZT', '0': 'GMT', '1': 'CET', '2': 'EET',
                '3': 'MSK', '4': 'GST', '5': 'IST', '5.5': 'IST', '6': 'BST',
                '7': 'ICT', '8': 'CST', '9': 'JST', '9.5': 'ACST', '10': 'AEST',
                '11': 'SBT', '12': 'NZST'
            };

            return timezones[hours.toString()] || `GMT${hours >= 0 ? '+' : ''}${hours}`;
        },

        // ---- Engineering Workforce Profile helpers --------------------------

        // True if `question` is one of the 4 EWP rows. Matched by canonical
        // title (the template-block helper stamps the same titles every
        // time) so we don't depend on the question_type_id or any custom
        // flag round-tripping through the worksheet load.
        isEwpQuestion(question) {
            if (!question?.title) return false;
            const t = String(question.title).trim().toLowerCase();
            return Object.prototype.hasOwnProperty.call(EWP_TITLES, t);
        },

        // Look up the AnswerBank field schema (the partner_field_info row
        // with dropdown_options + validation_rules) for an EWP question.
        // Returns null while ewpLoaded is false or for non-EWP questions.
        getEwpFieldItem(question) {
            if (!this.ewpLoaded || !question?.title) return null;
            const slug = EWP_TITLES[String(question.title).trim().toLowerCase()];
            return slug ? this.ewpFieldBySlug[slug] || null : null;
        },

        // Parse the JSON-stringified structured-table answer that lives on
        // question.response.answer. Returns null when the answer is empty
        // or not valid JSON -- StructuredTableComponent handles a null
        // modelValue by showing an empty table.
        parseEwpAnswer(answer) {
            if (answer == null || answer === '') return null;
            if (typeof answer === 'object') return answer;
            if (typeof answer === 'string') {
                try { return JSON.parse(answer); } catch (_e) { return null; }
            }
            return null;
        },

        // StructuredTableComponent emits objects (static) or arrays
        // (dynamic). The submission code path treats response.answer as a
        // string, so stringify before storing. Empty maps and empty arrays
        // round-trip cleanly.
        setEwpAnswer(question, value) {
            question.response.answer = value == null ? '' : JSON.stringify(value);
        },

        // One-shot loader: detects EWP questions in the opportunity payload,
        // fetches the 4 field schemas from AnswerBank's SE question_set
        // template endpoint, then fetches the vendor's existing answer-bank
        // values for prefill. Safe to call on every getOpportunityDetails
        // refresh -- it short-circuits once the schemas are loaded so we
        // don't hammer AnswerBank when the vendor saves a draft mid-form.
        async loadEwpSchemasAndPrefill() {
            const questions = this.opportunityDetails?.questions || [];
            const ewpQuestions = questions.filter((q) => this.isEwpQuestion(q));
            if (ewpQuestions.length === 0) {
                this.ewpLoaded = true;
                return;
            }

            // Fetch the 4 schemas once per session. The endpoint returns
            // the whole SE question_set; we extract the EWP fields by
            // field_name slug.
            if (!this.ewpLoaded || Object.keys(this.ewpFieldBySlug).length === 0) {
                try {
                    const base = process.env.VUE_APP_ANSWER_BANK_SERVICE_URL;
                    const seQsId = await getSeQsId(base);
                    const res = await getApi(
                        `v2/template/answer-bank/?qsid=${seQsId}&isAdmin=true`,
                        base
                    );
                    const sections = res?.data?.data?.data
                        || res?.data?.data
                        || res?.data
                        || [];
                    const fieldBySlug = {};
                    const slugByFieldId = {};
                    const targetSlugs = new Set(Object.values(EWP_TITLES));
                    for (const section of Array.isArray(sections) ? sections : []) {
                        const fields = Array.isArray(section?.data) ? section.data : [];
                        for (const field of fields) {
                            if (targetSlugs.has(field?.field_name)) {
                                fieldBySlug[field.field_name] = field;
                                slugByFieldId[field.id] = field.field_name;
                            }
                        }
                    }
                    this.ewpFieldBySlug = fieldBySlug;
                    this.ewpSlugByFieldId = slugByFieldId;
                } catch (err) {
                    console.warn('EWP: failed to fetch schemas from AnswerBank', err);
                    // Fall through -- the StructuredTableComponent v-if
                    // gates on getEwpFieldItem() so questions whose schema
                    // is missing keep the existing textarea render.
                }
            }

            // Prefill from the vendor's existing answer-bank values when
            // the per-RFP response is still blank. Doesn't overwrite a
            // saved draft or a previous submission.
            const slugByFieldId = this.ewpSlugByFieldId || {};
            const fieldIds = Object.keys(slugByFieldId);
            const partnerId = getAccountId();
            if (fieldIds.length > 0 && partnerId) {
                try {
                    const base = process.env.VUE_APP_ANSWER_BANK_SERVICE_URL;
                    const params = new URLSearchParams({
                        partnerIds: partnerId,
                        fieldIds: fieldIds.join(','),
                    }).toString();
                    const res = await getApi(`v1/answer-previewer?${params}`, base);
                    const previewerData = res?.data?.data || res?.data || [];
                    const myAnswers = (Array.isArray(previewerData) ? previewerData : [])
                        .find((row) => row.partnerId === partnerId);
                    const valueByFieldId = new Map();
                    for (const pv of myAnswers?.partnerValues || []) {
                        valueByFieldId.set(pv.fieldId, pv.value);
                    }
                    for (const q of ewpQuestions) {
                        const slug = EWP_TITLES[String(q.title).trim().toLowerCase()];
                        const field = this.ewpFieldBySlug[slug];
                        if (!field) continue;
                        // Only prefill if the response is still empty --
                        // a saved draft or submitted answer wins.
                        if (q.response?.answer) continue;
                        const ab = valueByFieldId.get(field.id);
                        if (ab == null) continue;
                        this.setEwpAnswer(q, ab);
                    }
                } catch (err) {
                    console.warn('EWP: failed to prefill from answer bank', err);
                }
            }

            this.ewpLoaded = true;
        },

        // Get the opportunity details
        async getOpportunityDetails() {
            if (this.termsAccepted) {
                try {
                    const response = await this.partnerOpportunityService.getOpportunityDetails({
                        encryptionId: this.opportunityId
                    });
                    if (response.status === 200) {
                        console.log("Get Opportunity Details Response:", response);
                        this.opportunityDetails = response.data;

                        // Process the answers for different question types
                        if (this.opportunityDetails?.questions) {
                            this.opportunityDetails.questions.forEach((q, idx) => {
                                if (!q.response) q.response = { answer: undefined, documents: [] };
                                if (q.response.documents !== undefined && q.response.documents !== null) {
                                    console.log('[getOpportunityDetails] question', idx, 'id=', q.id, 'title=', q.title, 'documents type=', typeof q.response.documents, 'value sample=', typeof q.response.documents === 'string' ? q.response.documents.substring(0, 60) + '...' : q.response.documents);
                                }
                                // Don't overwrite documents when API returned a value (string/object/array); processQuestions will normalize it
                                const hasDocsFromApi = q.response.documents !== undefined && q.response.documents !== null &&
                                    (typeof q.response.documents === 'string' ? q.response.documents.trim() !== '' : true);
                                if ((q.idQuestionType === 5 || q.canUploadFiles) && !hasDocsFromApi) {
                                    q.response.documents = [];
                                }
                            });
                            await this.processQuestions();
                            // EWP questions arrive with question_type_id = 1
                            // (plain text) because the RFP template helper
                            // does not know about structured_table. Detect
                            // them here, fetch their schemas from AnswerBank,
                            // and prefill the vendor's existing answer-bank
                            // value into question.response.answer so the
                            // StructuredTableComponent renders pre-populated.
                            await this.loadEwpSchemasAndPrefill();
                        }

                        if (this.opportunityDetails?.pricing_data) {
                            await this.transformPricingData();
                        }

                        if(this.opportunityDetails?.vendor_status_id === 9 || this.opportunityDetails?.vendor_status_id === 10 ) {
                            this.showPricingTable = true;
                            this.active = 0; // Start with the Request for Proposal tab
                        }

                        console.log("Set opportunityDetails:", this.opportunityDetails);
                        // Force a re-render of the company profile section
                        await this.$nextTick();
                        console.log("After nextTick - opportunityDetails:", this.opportunityDetails);
                        console.log("After nextTick - groupedQuestions:", this.groupedQuestions);

                        this.rfpEndTime = new Date(response.data.end_date);
                    }
                } catch (error) {
                    console.error('Error fetching opportunity details:', error);
                }
            } else {
                console.log("Terms not accepted yet");
            }
        },

        // Get the terms and conditions status
        async getTermsAndConditionsStatus() {
            try {
                const response = await this.partnerOpportunityService.getTermsAndConditionsStatus({
                    encryptionId: this.opportunityId
                });
                if (response.status === 200) {
                    // Show dialog if terms are not accepted
                    this.showTermsDialog = !response.data.termsAccepted;
                    this.termsAccepted = response.data.termsAccepted;
                }
            } catch (error) {
                console.error('Error fetching terms and conditions status:', error)
                this.showTermsDialog = true; // Show dialog on error to ensure user accepts terms
            }
        },

        // Update the terms and conditions
        async updateTermsAndConditions() {
            try {
                const response = await this.partnerOpportunityService.updateTermsAndConditions({
                    encryptionId: this.opportunityId
                });
                return response;
            } catch (error) {
                console.error('Error updating terms and conditions:', error);
                throw error; // Propagate error to handle it in the calling method
            }
        },

        // Handle the terms and conditions acceptance
        async onTermsAccepted() {
            if (this.accepting) return;
            this.accepting = true;
            try {
                const response = await this.updateTermsAndConditions();
                if (response && response.status === 200) {
                    this.termsAccepted = true;
                    this.showTermsDialog = false;
                    // Call getOpportunityDetails after accepting terms
                    await this.getOpportunityDetails();
                    // Start the countdown timer after loading opportunity details
                    this.startCountdown();
                } else {
                    // If update failed, keep dialog open
                    this.showTermsDialog = true;
                }
            } catch (error) {
                console.error('Error in terms acceptance:', error);
                this.showTermsDialog = true; // Keep dialog open on error
            } finally {
                this.accepting = false;
            }
        },

        // Start the countdown timer
        startCountdown() {
            this.updateCountdown();
            this.countdownInterval = setInterval(this.updateCountdown, 1000);
        },

        // Update the countdown timer
        updateCountdown() {
            const now = new Date();
            const diff = this.rfpEndTime - now;

            if (diff <= 0) {
                // If time is up, clear the interval and set countdown to null
                clearInterval(this.countdownInterval);
                this.countdown = null;
                return;
            }

            // Calculate time units
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);

            this.countdown = { days, hours, minutes, seconds };
        },

        // Handle the participation
        async onParticipate() {
            if (this.participating) return;
            this.participating = true;
            try {
                const response = await this.partnerOpportunityService.participate({
                    encryptionId: this.opportunityId
                });

                if (response.status === 200) {
                    // Show pricing table only after successful participation
                    this.showPricingTable = true;

                    // Refresh opportunity details to get updated status
                    await this.getOpportunityDetails();
                } else {
                    // Handle error case - you might want to show an error message
                    console.error('Failed to participate:', response);
                }
            } catch (error) {
                console.error('Error participating:', error);
                // Handle error case - you might want to show an error message
            } finally {
                this.participating = false;
            }
        },

        // Toggle the pricing table
        togglePricingTable() {
            this.showPricingTable = true;
            this.active = 0; // Start with the Request for Proposal tab
        },

        // Handle the next button
        // Navigation only -- no validation on the way back, matching the
        // toggle buttons above (@click="active = 0" etc.) which already let
        // vendors jump to any tab freely. Required-field validation stays
        // gated to handleNext's submit-time (last group) check only.
        handlePrevious() {
            if (this.active > 0) {
                this.active--;
            }
        },

        async handleNext() {
            // If RFP has ended, allow navigation without validation
            if (this.isRfpEnded) {
                if (this.active < this.opportunityDetails?.pricing_data.length) {
                    this.active++;
                } else {
                    const currentGroupIndex = this.active - this.opportunityDetails?.pricing_data.length;
                    const isLastGroup = currentGroupIndex === Object.keys(this.groupedQuestions).length - 1;

                    if (isLastGroup) {
                        // Show message that RFP has ended and submission is not possible
                        this.$toast.add({
                            severity: 'info',
                            summary: 'RFP Ended',
                            detail: 'This RFP has ended. You can view the content but cannot submit a response.',
                            life: 3000
                        });
                    } else {
                        this.active++;
                    }
                }
                return;
            }

            if (this.active === 0) {
                this.active++;
            }
            // Pricing tables section -- always advance. Required-field
            // validation only runs at submit time (final question group)
            // so vendors can navigate freely between tabs and back.
            else if (this.active > 0 && this.active <= this.opportunityDetails?.pricing_data.length) {
                this.active++;
            } else if (this.active > this.opportunityDetails?.pricing_data.length) {
                // We're in question groups section (subtract 1 because index 0 is intro)
                const currentGroupIndex = this.active - this.opportunityDetails?.pricing_data.length - 1;

                // Check if this is the last group (clicking Next here is
                // actually "Submit Response").
                const isLastGroup = currentGroupIndex === Object.keys(this.groupedQuestions).length - 1;

                if (isLastGroup) {
                    // Aggregate every missing mandatory field across all
                    // pricing tables + all question groups so the vendor
                    // sees the complete list at submit time, not just the
                    // last group's gaps.
                    const missingFields = [];
                    (this.opportunityDetails?.pricing_data || []).forEach((table) => {
                        (table.table_data?.rows || []).forEach((row, rowIndex) => {
                            (table.table_data?.columns || []).forEach((column) => {
                                if (column.isMandatory && column.input_source === 'vendor' && !row.data[column.id] && !table.table_data.allowNestedTables) {
                                    missingFields.push({
                                        table: table.table_name,
                                        row: rowIndex + 1,
                                        column: column.title,
                                    });
                                    row.data[column.id] = '';
                                }
                            });
                        });
                    });

                    const missingQuestions = [];
                    Object.values(this.groupedQuestions).forEach((group) => {
                        group.forEach((question) => {
                            if (!question.isMandatory) return;
                            const isFileOnlyType = question.idQuestionType === 5;
                            const hasNoFile = !this.isDocumentsArray(question.response.documents);
                            const hasNoAnswer = !question.response.answer;
                            if (isFileOnlyType && hasNoFile) {
                                missingQuestions.push({ question: question.title, type: 'file' });
                                question.response.answer = '';
                            } else if (!isFileOnlyType && hasNoAnswer) {
                                missingQuestions.push({ question: question.title, type: 'text' });
                                question.response.answer = '';
                            }
                        });
                    });

                    if (missingFields.length > 0 || missingQuestions.length > 0) {
                        console.log('Missing mandatory pricing fields:', missingFields);
                        console.log('Missing mandatory questions:', missingQuestions);
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Required Fields Missing',
                            detail: 'Please fill in all required fields before proceeding.',
                            life: 3000
                        });
                        return;
                    }
                }

                if (isLastGroup) {
                    // Double-click guard: a second click before the POST resolves would
                    // re-submit the same payload and duplicate every rfp_responses +
                    // rfp_pricing row. Mirror's the retract button's pattern.
                    if (this.submitting) return;
                    this.submitting = true;

                    // Handle submission
                    const submissionData = this.constructSubmissionData();
                    const payload = {
                        encryptionId: this.opportunityId,
                        submissionData: submissionData
                    };

                    try {
                        const response = await this.partnerOpportunityService.submitOpportunityResponse(payload);
                        console.log("Submission response:", response);

                        if (response.status === 200) {
                            this.$toast.add({
                                severity: 'success',
                                summary: 'Success',
                                detail: 'Your response has been submitted successfully.',
                                life: 3000
                            });
                            await this.getOpportunityDetails();

                            // Email Excel file to vendor
                            try {
                                await this.partnerOpportunityService.emailResponseExcel({
                                    encryptionId: this.opportunityId
                                });
                                this.$toast.add({
                                    severity: 'success',
                                    summary: 'Email Sent',
                                    detail: 'A copy of your responses has been emailed to you.',
                                    life: 4000
                                });
                            } catch (emailError) {
                                console.error('Error sending email:', emailError);
                                // Don't show error toast for email - it's not critical if it fails
                            }
                        }
                    } catch (error) {
                        console.error('Error submitting response:', error);
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to submit response. Please try again.',
                            life: 3000
                        });
                    } finally {
                        this.submitting = false;
                    }
                } else {
                    // Move to next tab
                    this.active++;
                }
            }
        },

        async handleSaveAsDraft() {
            // Double-click guard — same shape as the Submit Response guard. The draft
            // POST writes the same batch payload to /draft and can produce identical
            // duplicate rows if clicked twice while in flight.
            if (this.savingDraft) return;
            this.savingDraft = true;

            console.log("Saving as draft");
            const submissionData = this.constructSubmissionData();
            const payload = {
                encryptionId: this.opportunityId,
                submissionData: submissionData
            };

            console.log("Draft payload: >", payload);

            try {
                const response = await this.partnerOpportunityService.saveAsDraft(payload);
                console.log("Draft save response:", response);

                if (response.status === 200) {
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Your response has been saved as draft successfully.',
                        life: 3000
                    });
                    await this.getOpportunityDetails();
                }
            } catch (error) {
                console.error('Error saving draft:', error);
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to save draft. Please try again.',
                    life: 3000
                });
            } finally {
                this.savingDraft = false;
            }
        },

        // Toggle the intro
        // async toggleIntro() {
        //     await this.getOpportunityDetails()
        //     this.showPricingTable = false;
        //     this.active = 0;
        // },

        async downloadAttachment(attachment) {
            console.log("Downloading attachment", attachment);
            try {
                const response = await this.partnerOpportunityService.downloadAttachment({
                    fileName: attachment.fileName
                });

                if (response.status === 200) {
                    // Get the signed URL from the response
                    const signedUrl = response.data.downloadURL;

                    // Create a temporary link element
                    const link = document.createElement('a');
                    link.href = signedUrl;
                    link.download = attachment.fileName;
                    // Append to body, click and remove
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            } catch (error) {
                console.error('Error downloading attachment:', error);
                // You might want to show an error message to the user here
            }
        },

        formatTableData(table) {
            // Transform the rows data into a format suitable for DataTable
            return table.table_data.rows.map(row => {
                const formattedRow = {};
                // Add all column values to the row
                table.table_data.columns.forEach(column => {
                    formattedRow[column.id] = row.data[column.id] || '';
                });
                return formattedRow;
            });
        },

        async onFileChange(event, question) {
            const file = event.target.files[0];
            console.log("file >>", file);
            if (file) {
                // Check file size (5MB = 5 * 1024 * 1024 bytes)
                const maxSize = 5 * 1024 * 1024; // 5MB in bytes
                if (file.size > maxSize) {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'File Too Large',
                        detail: 'File size should not exceed 5MB. Please choose a smaller file.',
                        life: 3000
                    });
                    // Clear the file input
                    event.target.value = '';
                    return;
                }

                try {
                    // Set uploading state for this question
                    this.uploadingFileId = question.id;

                    // Get pre-signed URL for the file
                    const preSignedUrlResponse = await this.partnerOpportunityService.getPreSignedUrlForAttachment({
                        fileName: file.name
                    });

                    console.log("Pre-signed URL response ==>", preSignedUrlResponse, file);

                    if (preSignedUrlResponse.status === 200) {
                        // Upload file using pre-signed URL
                        const uploadResponse = await fetch(preSignedUrlResponse.data.uploadURL, {
                            method: 'PUT',
                            body: file,
                            headers: {
                                'Content-Type': file.type
                            }
                        });

                        console.log("Upload response ==>", uploadResponse);

                        if (uploadResponse.ok) {
                            // Store file information in question response
                            question.response.documents = [{
                                name: file.name,
                                fileUrl: preSignedUrlResponse.data.uploadURL.split('?')[0], // Get the base URL without query parameters
                                key: preSignedUrlResponse.data.Key
                            }];
                            question.response.questionTypeId = question.idQuestionType;
                        } else {
                            this.$toast.add({
                                severity: 'error',
                                summary: 'Upload Failed',
                                detail: 'Failed to upload file. Please try again.',
                                life: 3000
                            });
                        }
                    }
                } catch (error) {
                    console.error('Error uploading file:', error);
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Upload Failed',
                        detail: 'An error occurred while uploading the file. Please try again.',
                        life: 3000
                    });
                } finally {
                    // Clear uploading state
                    this.uploadingFileId = null;
                }
            }
        },

        removeFile(question) {
            question.response.documents = [];
            console.log("question.response.documents >>", question.response.documents);

            // Clear the file input value to allow re-selecting the same file
            this.$nextTick(() => {
                // Find the file input within the same question container
                const questionElement = document.querySelector(`[data-question-id="${question.id}"]`);
                if (questionElement) {
                    const fileInput = questionElement.querySelector('.file-upload-input');
                    if (fileInput) {
                        fileInput.value = '';
                    }
                }
            });
        },

        /** Get S3 key for API: backend expects the stored key (documentId), fallback to name */
        getFileKeyForApi(doc) {
            return doc && (doc.key || doc.documentId || doc.name) || doc;
        },

        async downloadFileFromQuestion(doc) {
            const fileKey = this.getFileKeyForApi(doc);
            const fileName = (doc && (doc.name || doc.documentName)) || fileKey;
            try {
                const response = await this.partnerOpportunityService.downloadAttachment({
                    fileName: fileKey
                });

                if (response.status === 200) {
                    const signedUrl = response.data.downloadURL;
                    const fileResponse = await fetch(signedUrl);
                    const blob = await fileResponse.blob();
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                }
            } catch (error) {
                console.error('Error downloading file:', error);
                this.$toast.add({
                    severity: 'error',
                    summary: 'Download Failed',
                    detail: 'An error occurred while downloading the file. Please try again.',
                    life: 3000
                });
            }
        },

        async viewFile(doc) {
            const fileKey = this.getFileKeyForApi(doc);
            try {
                const response = await this.partnerOpportunityService.downloadAttachment({
                    fileName: fileKey
                });
                if (response.status === 200 && response.data.downloadURL) {
                    window.open(response.data.downloadURL, '_blank', 'noopener,noreferrer');
                }
            } catch (error) {
                console.error('Error opening file:', error);
                this.$toast.add({
                    severity: 'error',
                    summary: 'View Failed',
                    detail: 'An error occurred while opening the file. Please try again.',
                    life: 3000
                });
            }
        },

        async downloadFile(fileName) {
            await this.downloadFileFromQuestion({ name: fileName, key: fileName });
        },

        constructSubmissionData() {
            // Format questions data
            const answers = this.opportunityDetails.questions.map(question => {
                const answer = {
                    questionId: question.id,
                    questionTypeId: question.idQuestionType,
                    documents: []
                };

                // Handle different question types
                switch (question.idQuestionType) {
                    case 5: // File Upload
                        if (this.isDocumentsArray(question.response.documents)) {
                            answer.documents = question.response.documents.map(doc => ({
                                documentId: doc.key || doc.documentId,
                                documentName: doc.name || doc.documentName
                            }));
                        }
                        break;

                    case 1: // Long text
                    case 4: // Short text — may also allow file when canUploadFiles
                        answer.answer = question.response.answer;
                        if (question.canUploadFiles && this.isDocumentsArray(question.response.documents)) {
                            answer.documents = question.response.documents.map(doc => ({
                                documentId: doc.key || doc.documentId,
                                documentName: doc.name || doc.documentName
                            }));
                        }
                        break;

                    case 2: // Single Choice
                    case 6: // Dropdown single choice
                        if (question.response.answer) {
                            const option = question.options.find(opt => opt.id === question.response.answer);
                            answer.answer = option ? option.optionValue : '';
                        }
                        break;

                    case 3: // Multiple Choice
                    case 7: // Dropdown multiple choice
                        if (question.response.answer && Array.isArray(question.response.answer)) {
                            answer.answer = question.response.answer
                                .map(id => {
                                    const option = question.options.find(opt => opt.id === id);
                                    return option ? option.optionValue : '';
                                })
                                .filter(value => value !== '');
                        }
                        break;

                    case 8: // Number
                    case 9: // Date
                        answer.answer = question.response.answer;
                        break;
                }

                // Include documents for any question type when canUploadFiles and has attachments
                if (question.canUploadFiles && this.isDocumentsArray(question.response.documents)) {
                    answer.documents = question.response.documents.map(doc => ({
                        documentId: doc.key || doc.documentId,
                        documentName: doc.name || doc.documentName
                    }));
                }

                return answer;
            });

            // Format pricing data - flatten nested tables into main tables
            const pricing_data = this.opportunityDetails.pricing_data.reduce((acc, table) => {
                // Add main table
                acc.push({
                    table_name: table.table_name,
                    table_data: {
                        id: table.table_data.id,
                        rows: table.table_data.rows,
                        columns: table.table_data.columns,
                        sort_order: table.table_data.sort_order,
                        hasNestedTables: table.table_data.hasNestedTables,
                        allowNestedTables: table.table_data.allowNestedTables !== undefined ? table.table_data.allowNestedTables : false
                    }
                });

                // Add nested tables as main tables with parent reference
                if (table.nestedTables && table.nestedTables.length > 0) {
                    table.nestedTables.forEach(nestedTable => {
                        acc.push({
                            table_name: nestedTable.table_name,
                            table_data: {
                                rows: nestedTable.table_data.rows,
                                columns: nestedTable.table_data.columns,
                                sort_order: nestedTable.table_data.sort_order,
                                parent_table_id: table.table_data.id
                            }
                        });
                    });
                }

                return acc;
            }, []);

            return {
                answers,
                pricing_data
            };
        },

        async exportResponsesToExcel() {
            try {
                const workbook = new Workbook();
                
                // Excel sheet names and filenames cannot contain: \ / ? * [ ]
                const invalidCharsRegex = new RegExp('[\\\\/?*\\[\\]]', 'g');
                
                // Helper function to get answer text based on question type
                const getAnswerText = (question) => {
                    if (!question.response) return '';

                    // Engineering Workforce Profile answers are stored as
                    // JSON strings under question_type 1. The default case
                    // below would dump the raw JSON ({"junior":"1-25%",...})
                    // into the cell, so format them readably first.
                    const ewpFormatted = formatEwpAnswerForDownload(question);
                    if (ewpFormatted !== null) return ewpFormatted;

                    switch (question.idQuestionType) {
                        case 1: // Long text
                        case 4: // Short text
                            return question.response.answer || '';
                        
                        case 2: // Single Choice
                        case 6: // Dropdown single choice
                            if (question.response.answer) {
                                const option = question.options?.find(opt => opt.id === question.response.answer);
                                return option ? option.optionValue : '';
                            }
                            return '';
                        
                        case 3: // Multiple Choice
                        case 7: // Dropdown multiple choice
                            if (question.response.answer && Array.isArray(question.response.answer)) {
                                return question.response.answer
                                    .map(id => {
                                        const option = question.options?.find(opt => opt.id === id);
                                        return option ? option.optionValue : '';
                                    })
                                    .filter(value => value !== '')
                                    .join(', ');
                            }
                            return '';
                        
                        case 5: // File Upload
                            if (this.isDocumentsArray(question.response.documents)) {
                                return question.response.documents.map(doc => doc.name).join(', ');
                            }
                            return '';
                        
                        case 8: // Number
                            return question.response.answer?.toString() || '';
                        
                        case 9: // Date
                            return question.response.answer ? moment(question.response.answer).format('MM/DD/YYYY') : '';
                        
                        default:
                            return question.response.answer?.toString() || '';
                    }
                };

                // Create a separate sheet for each question group
                if (this.opportunityDetails.questions && this.opportunityDetails.questions.length > 0) {
                    // Group questions by group name
                    const groupedQuestions = {};
                    this.opportunityDetails.questions.forEach(question => {
                        const groupName = question.questionGroup || 'General';
                        if (!groupedQuestions[groupName]) {
                            groupedQuestions[groupName] = [];
                        }
                        groupedQuestions[groupName].push(question);
                    });
                    
                    // Create a sheet for each question group
                    Object.keys(groupedQuestions).forEach(groupName => {
                        // Sanitize sheet name (Excel limit is 31 characters)
                        let sheetName = (groupName || 'General').trim();
                        sheetName = sheetName.replace(invalidCharsRegex, '_');
                        if (sheetName.length > 31) {
                            sheetName = sheetName.substring(0, 31);
                        }
                        
                        const questionsSheet = workbook.addWorksheet(sheetName);
                        
                        // Add headers
                        questionsSheet.columns = [
                            { header: 'Question', key: 'question', width: 50 },
                            { header: 'Answer', key: 'answer', width: 50 },
                            { header: 'Required', key: 'required', width: 12 }
                        ];
                        
                        // Style header row
                        const headerRow = questionsSheet.getRow(1);
                        headerRow.font = { bold: true };
                        headerRow.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FFE0E0E0' }
                        };
                        
                        // Add question rows for this group
                        groupedQuestions[groupName].forEach(question => {
                            questionsSheet.addRow({
                                question: question.title || '',
                                answer: getAnswerText(question),
                                required: question.isMandatory ? 'Yes' : 'No'
                            });
                        });
                    });
                }

                // Create Pricing Tables sheets
                if (this.opportunityDetails.pricing_data && this.opportunityDetails.pricing_data.length > 0) {
                    this.opportunityDetails.pricing_data.forEach((table, tableIndex) => {
                        // If table has nested tables, create sheets for nested tables only
                        // Otherwise, create a sheet for the parent table
                        if (table.nestedTables && table.nestedTables.length > 0) {
                            // Create a sheet for each nested table with format "Parent Name - Child Name"
                            table.nestedTables.forEach((nestedTable, nestedIndex) => {
                                // Get parent and child names
                                const parentName = (table.table_name || `Pricing Table ${tableIndex + 1}`).trim();
                                const childName = (nestedTable.table_name || `Location - ${nestedIndex + 1}`).trim();
                                
                                // Combine names with separator
                                const separator = ' - ';
                                let combinedName = `${parentName}${separator}${childName}`;
                                
                                // Sanitize invalid characters
                                combinedName = combinedName.replace(invalidCharsRegex, '_');
                                
                                // Truncate to Excel's 31 character limit
                                // Priority: preserve child name, truncate parent if needed
                                if (combinedName.length > 31) {
                                    const separatorLength = separator.length;
                                    const maxLength = 31;
                                    
                                    // Reserve space for separator and child name
                                    // Ensure child name fits (at least truncate it if too long)
                                    const maxChildLength = Math.min(childName.length, maxLength - separatorLength);
                                    const remainingForParent = maxLength - separatorLength - maxChildLength;
                                    
                                    const truncatedParent = parentName.substring(0, Math.max(0, remainingForParent));
                                    const truncatedChild = childName.substring(0, maxChildLength);
                                    
                                    combinedName = `${truncatedParent}${separator}${truncatedChild}`;
                                    // Re-sanitize after truncation
                                    combinedName = combinedName.replace(invalidCharsRegex, '_');
                                }
                                
                                const sheetName = combinedName.substring(0, 31);
                                
                                const nestedSheet = workbook.addWorksheet(sheetName);
                                
                                // Only include nested table (child) data
                                const nestedColumns = nestedTable.table_data?.columns || [];
                                if (nestedColumns.length > 0) {
                                    // Add header row
                                    const nestedHeaders = nestedColumns.map(col => col.title || col.id);
                                    nestedSheet.addRow(nestedHeaders);
                                    
                                    // Style header row
                                    const nestedHeaderRow = nestedSheet.getRow(1);
                                    nestedHeaderRow.font = { bold: true };
                                    nestedHeaderRow.fill = {
                                        type: 'pattern',
                                        pattern: 'solid',
                                        fgColor: { argb: 'FFE0E0E0' }
                                    };
                                    
                                    // Set column widths
                                    nestedColumns.forEach((col, index) => {
                                        nestedSheet.getColumn(index + 1).width = 20;
                                    });
                                    
                                    // Add data rows (only nested table data)
                                    const nestedRows = nestedTable.table_data?.rows || [];
                                    nestedRows.forEach(row => {
                                        const nestedRowData = nestedColumns.map(col => {
                                            const value = row.data?.[col.id];
                                            return value !== null && value !== undefined ? value.toString() : '';
                                        });
                                        nestedSheet.addRow(nestedRowData);
                                    });
                                }
                            });
                        } else {
                            // No nested tables - create a sheet for the parent table
                            const sheetName = (table.table_name || `Pricing Table ${tableIndex + 1}`)
                                .substring(0, 31)
                                .replace(invalidCharsRegex, '_');
                            
                            const pricingSheet = workbook.addWorksheet(sheetName);
                            
                            // Get columns
                            const columns = table.table_data?.columns || [];
                            if (columns.length > 0) {
                                // Add header row
                                const headers = columns.map(col => col.title || col.id);
                                pricingSheet.addRow(headers);
                                
                                // Style header row
                                const headerRow = pricingSheet.getRow(1);
                                headerRow.font = { bold: true };
                                headerRow.fill = {
                                    type: 'pattern',
                                    pattern: 'solid',
                                    fgColor: { argb: 'FFE0E0E0' }
                                };
                                
                                // Set column widths
                                columns.forEach((col, index) => {
                                    pricingSheet.getColumn(index + 1).width = 20;
                                });
                                
                                // Add data rows
                                const rows = table.table_data?.rows || [];
                                rows.forEach(row => {
                                    const rowData = columns.map(col => {
                                        const value = row.data?.[col.id];
                                        return value !== null && value !== undefined ? value.toString() : '';
                                    });
                                    pricingSheet.addRow(rowData);
                                });
                            }
                        }
                    });
                }

                // Generate filename
                const timestamp = moment().format('YYYY-MM-DD_HH-mm-ss');
                const rfpName = (this.opportunityDetails?.prokuria_rfp_name || 'RFP')
                    .replace(invalidCharsRegex, '_')
                    .substring(0, 50);
                const filename = `${rfpName}_Response_${timestamp}.xlsx`;

                // Write to buffer and download
                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(blob, filename);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Export Successful',
                    detail: 'Your responses have been exported to Excel.',
                    life: 3000
                });
            } catch (error) {
                console.error('Error exporting to Excel:', error);
                this.$toast.add({
                    severity: 'error',
                    summary: 'Export Failed',
                    detail: 'An error occurred while exporting to Excel. Please try again.',
                    life: 3000
                });
            }
        },

        handleRetractResponse() {
            this.showRetractDialog = true;
        },

        handleDecline() {
            this.showDeclineDialog = true;
        },

        async confirmDecline() {
            try {
                this.declining = true;
                const response = await this.partnerOpportunityService.decline({
                    encryptionId: this.opportunityId
                });

                if (response.status === 200) {
                    // Close the dialog
                    this.showDeclineDialog = false;
                    // Refresh opportunity details to get updated status
                    await this.getOpportunityDetails();

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Opportunity has been declined successfully.',
                        life: 3000
                    });
                }
            } catch (error) {
                console.error('Error declining opportunity:', error);
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to decline opportunity. Please try again.',
                    life: 3000
                });
            } finally {
                this.declining = false;
            }
        },

        async confirmRetract() {
            try {
                this.retracting = true;
                const response = await this.partnerOpportunityService.retractResponse({
                    encryptionId: this.opportunityId
                });

                if (response.status === 200) {
                    // Preserve attachments (documents) before refetch — API may not return them after retract
                    const documentsToPreserve = {};
                    this.opportunityDetails?.questions?.forEach(q => {
                        const docs = q.response?.documents;
                        const hasDocs = docs && (
                            Array.isArray(docs) ? docs.length > 0 : (docs.documentId || docs.documentName || docs.key || docs.name)
                        );
                        if (hasDocs) {
                            const key = String(q.id);
                            documentsToPreserve[key] = Array.isArray(docs)
                                ? docs.map(d => ({ key: d.key || d.documentId, name: d.name || d.documentName, fileUrl: d.fileUrl || d.key || d.documentId }))
                                : { key: docs.documentId || docs.key, name: docs.documentName || docs.name, fileUrl: docs.documentId || docs.key };
                        }
                    });

                    // Close the dialog
                    this.showRetractDialog = false;
                    // Refresh opportunity details to get updated status
                    await this.getOpportunityDetails();

                    // Restore preserved attachments so they are not lost after retract
                    if (this.opportunityDetails?.questions && Object.keys(documentsToPreserve).length > 0) {
                        this.opportunityDetails.questions.forEach(q => {
                            const key = String(q.id);
                            if (documentsToPreserve[key]) {
                                if (!q.response) q.response = {};
                                const saved = documentsToPreserve[key];
                                const normalized = Array.isArray(saved)
                                    ? saved.map(d => ({ key: d.key || d.documentId, name: d.name || d.documentName, fileUrl: d.fileUrl || d.key }))
                                    : [{ key: saved.documentId || saved.key, name: saved.documentName || saved.name, fileUrl: saved.documentId || saved.key }];
                                q.response.documents = normalized;
                            }
                        });
                        await this.$nextTick();
                    }

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Response has been retracted successfully.',
                        life: 3000
                    });
                }
            } catch (error) {
                console.error('Error retracting response:', error);
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to retract response. Please try again.',
                    life: 3000
                });
            } finally {
                this.retracting = false;
            }
        },

        addNestedTable(parentTableIndex) {
            if (!this.opportunityDetails.pricing_data[parentTableIndex].nestedTables) {
                this.opportunityDetails.pricing_data[parentTableIndex].nestedTables = [];
            }

            const parentTable = this.opportunityDetails.pricing_data[parentTableIndex];

            // Create a deep copy of the parent table including all data
            const newNestedTable = {
                table_name: `Location - ${parentTable.nestedTables.length + 1}`,
                table_data: {
                    rows: parentTable.table_data.rows.map(row => ({
                        id: `row_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
                        data: JSON.parse(JSON.stringify(row.data)), // Deep copy of row data
                        sort_order: row.sort_order
                    })),
                    columns: JSON.parse(JSON.stringify(parentTable.table_data.columns)), // Deep copy of columns
                    sort_order: parentTable.table_data.sort_order,
                    hasNestedTables: parentTable.table_data.hasNestedTables
                }
            };

            parentTable.nestedTables.push(newNestedTable);
            console.log("parentTable >>", parentTable);
            parentTable.table_data.hasNestedTables = true;
            this.activeNestedTable[parentTableIndex] = parentTable.nestedTables.length - 1;

            // Automatically start editing the name of the newly created table
            this.$nextTick(() => {
                this.startEditNestedTableName(parentTableIndex, parentTable.nestedTables.length - 1);
            });
        },

        removeNestedTable(parentTableIndex, nestedTableIndex) {
            const parentTable = this.opportunityDetails.pricing_data[parentTableIndex];

            // Safety check: ensure parent table and nested tables exist
            if (!parentTable || !parentTable.nestedTables || nestedTableIndex === undefined) {
                console.warn('Invalid nested table removal attempt:', { parentTableIndex, nestedTableIndex });
                return;
            }

            // Safety check: ensure the nested table index is valid
            if (nestedTableIndex < 0 || nestedTableIndex >= parentTable.nestedTables.length) {
                console.warn('Invalid nested table index:', nestedTableIndex);
                return;
            }

            parentTable.nestedTables.splice(nestedTableIndex, 1);

            console.log("parentTable >>", parentTable);
            // Update hasNestedTables based on remaining nested tables
            parentTable.table_data.hasNestedTables = parentTable.nestedTables.length > 0;

            // Reset active nested table if needed
            if (this.activeNestedTable[parentTableIndex] !== undefined) {
                if (parentTable.nestedTables.length === 0) {
                    // No nested tables left, remove the active state
                    delete this.activeNestedTable[parentTableIndex];
                } else if (this.activeNestedTable[parentTableIndex] >= parentTable.nestedTables.length) {
                    // Current active index is now out of bounds, reset to 0
                    this.activeNestedTable[parentTableIndex] = 0;
                }
            }
        },

        // New method to process questions
        async processQuestions() {
            return new Promise((resolve) => {
                this.opportunityDetails.questions.forEach(question => {
                    if (question.response) {
                        // Normalize documents for every question that has response.documents (any question type)
                        if (question.response.documents !== undefined && question.response.documents !== null) {
                            const before = question.response.documents;
                            question.response.documents = this.parseDocumentsFromApi(question.response.documents);
                            console.log('[processQuestions] question id=', question.id, 'title=', question.title, 'before sample=', typeof before === 'string' ? before.substring(0, 50) + '...' : before, 'after length=', Array.isArray(question.response.documents) ? question.response.documents.length : '-', 'after=', question.response.documents);
                        }
                        if ((question.idQuestionType === 5 || question.canUploadFiles) && !question.response.documents) {
                            question.response.documents = [];
                        }

                        if (question.idQuestionType === 2) {
                            // For single choice, convert array of one string to option ID
                            if (question.response.answer) {
                                const answerText = Array.isArray(question.response.answer)
                                    ? question.response.answer[0]
                                    : question.response.answer;
                                const option = question.options.find(opt => opt.optionValue === answerText);
                                question.response.answer = option ? option.id : null;
                            }
                        } else if (question.idQuestionType === 3) {
                            // For multiple choice, convert array of strings to option IDs
                            if (question.response.answer) {
                                const selectedOptions = question.response.answer.map(answerText => {
                                    const option = question.options.find(opt => opt.optionValue === answerText);
                                    return option ? option.id : null;
                                }).filter(id => id !== null);

                                question.response.answer = selectedOptions;
                            }
                        } else if (question.idQuestionType === 9) {
                            // For date type, convert string to Date object
                            if (question.response.answer) {
                                question.response.answer = new Date(question.response.answer);
                            }
                        } else if (question.idQuestionType === 8) {
                            // Remove commas from number input when loading data
                            if (question.response.answer && typeof question.response.answer === 'string') {
                                question.response.answer = question.response.answer.replace(/,/g, '');
                                const numValue = Number(question.response.answer);
                                question.response.answer = isNaN(numValue) ? null : numValue;
                            }
                            if (question.response.answer === '0' || question.response.answer === 0) {
                                question.response.answer = null;
                            }
                        }
                    }
                });
                resolve();
            });
        },

        // New method to transform pricing data
        async transformPricingData() {
            return new Promise((resolve) => {
                // Transform flat pricing data into nested structure
                const pricingDataMap = new Map();
                const nestedPricingData = [];

                // Store current activeNestedTable state before transformation
                const currentActiveNestedTable = { ...this.activeNestedTable };
                const tableIndexMap = new Map(); // Map to track old table indices to new ones

                // First pass: Create map of all tables
                this.opportunityDetails.pricing_data.forEach((table, index) => {
                    console.log("Creating map for table:", table.table_name, "ID:", table.table_data.id);
                    pricingDataMap.set(table.table_data.id, {
                        ...table,
                        nestedTables: []
                    });
                    tableIndexMap.set(index, table.table_data.id);
                });

                // Second pass: Build nested structure
                this.opportunityDetails.pricing_data.forEach(table => {
                    console.log("Processing table:", table.table_name, "Parent ID:", table.table_data.parent_table_id);
                    if (table.table_data.parent_table_id) {
                        // This is a nested table
                        const parentTable = pricingDataMap.get(table.table_data.parent_table_id);
                        if (parentTable) {
                            console.log("Adding nested table to parent:", parentTable.table_name);
                            parentTable.nestedTables.push(table);
                        } else {
                            console.log("Parent table not found for:", table.table_name);
                        }
                    } else {
                        // This is a parent table
                        console.log("Adding parent table:", table.table_name);
                        nestedPricingData.push(pricingDataMap.get(table.table_data.id));
                    }
                });

                // Sort parent tables by sort_order
                nestedPricingData.sort((a, b) => {
                    const sortOrderA = a.table_data.sort_order ?? 0;
                    const sortOrderB = b.table_data.sort_order ?? 0;
                    return sortOrderA - sortOrderB;
                });

                this.opportunityDetails.pricing_data = nestedPricingData;

                // Third pass: Auto-create nested tables for parent tables that allow them but have none
                nestedPricingData.forEach((table, tableIndex) => {
                    if (table.table_data.allowNestedTables && (!table.nestedTables || table.nestedTables.length === 0)) {
                        console.log("Auto-creating nested table for:", table.table_name);

                        // Create a nested table from the parent table
                        const autoNestedTable = {
                            table_name: `Location - 1`,
                            table_data: {
                                rows: table.table_data.rows.map(row => ({
                                    id: `row_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
                                    data: JSON.parse(JSON.stringify(row.data)), // Deep copy of row data
                                    sort_order: row.sort_order
                                })),
                                columns: JSON.parse(JSON.stringify(table.table_data.columns)), // Deep copy of columns
                                sort_order: table.table_data.sort_order,
                                hasNestedTables: false,
                                parent_table_id: table.table_data.id
                            }
                        };

                        // Initialize nestedTables array if it doesn't exist
                        if (!table.nestedTables) {
                            table.nestedTables = [];
                        }

                        // Add the auto-created nested table
                        table.nestedTables.push(autoNestedTable);
                        table.table_data.hasNestedTables = true;

                        // Set this as the active nested table
                        this.activeNestedTable[tableIndex] = 0;

                        console.log("Auto-created nested table:", autoNestedTable.table_name);
                    }

                    // Sort nested tables by sort_order
                    if (table.nestedTables && table.nestedTables.length > 0) {
                        table.nestedTables.sort((a, b) => {
                            const sortOrderA = a.table_data.sort_order ?? 0;
                            const sortOrderB = b.table_data.sort_order ?? 0;
                            return sortOrderA - sortOrderB;
                        });
                    }

                    // Sort rows within the table by sort_order
                    if (table.table_data.rows && table.table_data.rows.length > 0) {
                        table.table_data.rows.sort((a, b) => {
                            const sortOrderA = a.sort_order ?? 0;
                            const sortOrderB = b.sort_order ?? 0;
                            return sortOrderA - sortOrderB;
                        });
                    }

                    // Sort rows within nested tables by sort_order
                    if (table.nestedTables && table.nestedTables.length > 0) {
                        table.nestedTables.forEach(nestedTable => {
                            if (nestedTable.table_data.rows && nestedTable.table_data.rows.length > 0) {
                                nestedTable.table_data.rows.sort((a, b) => {
                                    const sortOrderA = a.sort_order ?? 0;
                                    const sortOrderB = b.sort_order ?? 0;
                                    return sortOrderA - sortOrderB;
                                });
                            }
                        });
                    }
                });

                // Restore activeNestedTable state with new indices
                const newActiveNestedTable = {};
                nestedPricingData.forEach((table, newIndex) => {
                    // Find the old index for this table
                    const oldIndex = Array.from(tableIndexMap.entries()).find(([oldIdx, tableId]) =>
                        tableId === table.table_data.id
                    )?.[0];

                    if (oldIndex !== undefined && currentActiveNestedTable[oldIndex] !== undefined) {
                        // Check if the nested table index is still valid
                        const nestedTableIndex = currentActiveNestedTable[oldIndex];
                        if (table.nestedTables && nestedTableIndex < table.nestedTables.length) {
                            newActiveNestedTable[newIndex] = nestedTableIndex;
                        }
                    }
                });

                // Merge with auto-created active nested tables
                this.activeNestedTable = { ...newActiveNestedTable, ...this.activeNestedTable };

                // Clean up any invalid states
                this.cleanupActiveNestedTableState();

                console.log("Final nested structure:", this.opportunityDetails.pricing_data);
                console.log("Restored activeNestedTable:", this.activeNestedTable);
                resolve();
            });
        },

        // Simple method to clean up invalid activeNestedTable states
        cleanupActiveNestedTableState() {
            const validState = {};
            this.opportunityDetails.pricing_data.forEach((table, tableIndex) => {
                if (this.activeNestedTable[tableIndex] !== undefined) {
                    const nestedIndex = this.activeNestedTable[tableIndex];
                    if (table.nestedTables && nestedIndex >= 0 && nestedIndex < table.nestedTables.length) {
                        validState[tableIndex] = nestedIndex;
                    }
                }
            });
            this.activeNestedTable = validState;
        },

        openMessageSidebar() {
            this.selectedMessage = { title: 'ArenaCX', body: 'This is a sample message.' };
            this.showMessageSidebar = true;
        },
        closeMessageSidebar() {
            this.showMessageSidebar = false;
            this.selectedMessage = null;
            this.isCreatingMessage = false;
        },
        startNewMessage() {
            this.isCreatingMessage = true;
        },

        // Validation methods for tab navigation
        validateTabNavigation(oldActive, newActive) {
            // If RFP has ended, allow navigation without validation
            if (this.isRfpEnded) {
                return true;
            }

            // Store the previous active tab to revert if validation fails
            const previousActive = oldActive;

            // Validate the current tab before allowing navigation
            if (this.validateCurrentTab(oldActive)) {
                // Validation passed, allow navigation
                return true;
            } else {
                // Validation failed, revert to previous tab
                this.$nextTick(() => {
                    this.active = previousActive;
                });
                return false;
            }
        },

        validateCurrentTab(tabIndex) {
            // Tab index 0 is the intro content (Request for Proposal), no validation needed
            if (tabIndex === 0) {
                return true;
            }

            const pricingDataLength = this.opportunityDetails?.pricing_data?.length || 0;

            if (tabIndex <= pricingDataLength) {
                // This is a pricing table tab (subtract 1 because index 0 is intro)
                return this.validatePricingTable(tabIndex - 1);
            } else {
                // This is a question group tab (subtract 1 because index 0 is intro)
                const questionGroupIndex = tabIndex - pricingDataLength - 1;
                return this.validateQuestionGroup(questionGroupIndex);
            }
        },

        validatePricingTable(tableIndex) {
            const table = this.opportunityDetails.pricing_data[tableIndex];
            if (!table) return true;

            let missingFields = [];

            // Always validate main table
            table.table_data.rows.forEach((row, rowIndex) => {
                table.table_data.columns.forEach(column => {
                    if (column.isMandatory && column.input_source === 'vendor' && !row.data[column.id] && !table.table_data.allowNestedTables) {
                        console.log("Missing field Main >>:", column.title);
                        missingFields.push({
                            table: table.table_name,
                            row: rowIndex + 1,
                            column: column.title
                        });
                    }
                });
            });

            // Validate all nested tables if they exist
            if (table.nestedTables && table.nestedTables.length > 0) {
                table.nestedTables.forEach((nestedTable) => {
                    nestedTable.table_data.rows.forEach((row, rowIndex) => {
                        nestedTable.table_data.columns.forEach(column => {
                            if (column.isMandatory && column.input_source === 'vendor' && !row.data[column.id]) {
                                console.log("Missing field Nested >>:", column.title, "in table:", nestedTable.table_name);
                                missingFields.push({
                                    table: nestedTable.table_name,
                                    row: rowIndex + 1,
                                    column: column.title
                                });
                            }
                        });
                    });
                });
            }

            if (missingFields.length > 0) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Required Fields Missing',
                    detail: 'Please fill in all required fields before proceeding.',
                    life: 3000
                });
                return false;
            }

            return true;
        },

        validateQuestionGroup(groupIndex) {
            const groups = Object.values(this.groupedQuestions);
            const currentGroup = groups[groupIndex];

            if (!currentGroup) return true;

            let missingQuestions = [];

            currentGroup.forEach(question => {
                if (question.isMandatory) {
                    const isFileOnlyType = question.idQuestionType === 5;
                    const hasNoFile = !this.isDocumentsArray(question.response.documents);
                    const hasNoAnswer = !question.response.answer;

                    if (isFileOnlyType && hasNoFile) {
                        missingQuestions.push({
                            question: question.title,
                            type: 'file'
                        });
                    } else if (!isFileOnlyType && hasNoAnswer) {
                        missingQuestions.push({
                            question: question.title,
                            type: 'text'
                        });
                    }
                }
            });

            if (missingQuestions.length > 0) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Required Fields Missing',
                    detail: 'Please fill in all required fields before proceeding.',
                    life: 3000
                });
                return false;
            }

            return true;
        },

        startEditNestedTableName(tableIndex, nestedIndex) {
            const nestedTable = this.opportunityDetails.pricing_data[tableIndex].nestedTables[nestedIndex];
            this.editingNestedTableName = {
                tableIndex,
                nestedIndex,
                newName: nestedTable.table_name
            };

            // Focus the input after it's rendered
            this.$nextTick(() => {
                if (this.$refs.nestedTableNameInput) {
                    this.$refs.nestedTableNameInput[0].focus();
                    this.$refs.nestedTableNameInput[0].select();
                }
            });
        },

        confirmEditNestedTableName(tableIndex, nestedIndex) {
            const newName = this.editingNestedTableName.newName.trim();

            if (!newName) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Invalid Name',
                    detail: 'Table name cannot be empty.',
                    life: 3000
                });
                return;
            }

            // Check if name already exists (excluding current table)
            const existingNames = this.opportunityDetails.pricing_data[tableIndex].nestedTables
                .map((table, index) => index !== nestedIndex ? table.table_name : null)
                .filter(name => name !== null);

            if (existingNames.includes(newName)) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Duplicate Name',
                    detail: 'A table with this name already exists.',
                    life: 3000
                });
                return;
            }

            // Update the table name
            this.opportunityDetails.pricing_data[tableIndex].nestedTables[nestedIndex].table_name = newName;

            // Reset editing state
            this.editingNestedTableName = { tableIndex: null, nestedIndex: null, newName: '' };

            this.$toast.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Table name updated successfully.',
                life: 2000
            });
        },

        cancelEditNestedTableName() {
            this.editingNestedTableName = { tableIndex: null, nestedIndex: null, newName: '' };
        },

        async downloadContractTemplate() {
            if (!this.opportunityDetails?.vendor_contract_s3_file_key) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Download Failed',
                    detail: 'Contract template is not available for download.',
                    life: 3000
                });
                return;
            }

            try {
                // Get the signed URL for the contract template
                const response = await this.partnerOpportunityService.downloadAttachment({
                    fileName: this.opportunityDetails.vendor_contract_s3_file_key
                });

                if (response.status === 200) {
                    // Get the signed URL from the response
                    const signedUrl = response.data.downloadURL;

                    // Fetch the file as blob
                    const fileResponse = await fetch(signedUrl);
                    const blob = await fileResponse.blob();

                    // Create object URL
                    const url = window.URL.createObjectURL(blob);

                    // Create a temporary link element
                    const link = document.createElement('a');
                    link.href = url;
                    
                    // Set the download filename to use prokuria_rfp_name
                    const baseFileName = this.opportunityDetails?.prokuria_rfp_name || 'contract-template';
                    // Ensure the filename has the correct extension
                    const fileName = baseFileName.endsWith('.docx') ? baseFileName : `${baseFileName}.docx`;
                    link.download = fileName;
                    
                    // Append to body, click and remove
                    document.body.appendChild(link);
                    link.click();

                    // Clean up
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Download Started',
                        detail: 'Contract template download has started.',
                        life: 3000
                    });
                } else {
                    throw new Error('Failed to get download URL');
                }
            } catch (error) {
                console.error('Error downloading contract template:', error);
                this.$toast.add({
                    severity: 'error',
                    summary: 'Download Failed',
                    detail: 'An error occurred while downloading the contract template. Please try again.',
                    life: 3000
                });
            }
        }
    },
    computed: {
        groupedQuestions() {
            console.log("Computing groupedQuestions - opportunityDetails:", this.opportunityDetails);
            if (!this.opportunityDetails?.questions) {
                console.log("No questions found in opportunityDetails");
                return {};
            }

            const groups = this.opportunityDetails.questions.reduce((groups, question) => {
                const groupName = question.questionGroup || 'Other';
                if (!groups[groupName]) {
                    groups[groupName] = [];
                }
                groups[groupName].push(question);
                return groups;
            }, {});

            console.log("Computed groups:", groups);
            return groups;
        },
        isLastTab() {
            const totalTabs = 1 + (this.opportunityDetails?.pricing_data?.length || 0) + Object.keys(this.groupedQuestions).length;
            return this.active === totalTabs - 1;
        },
        isRfpEnded() {
            return this.rfpEndTime && new Date() > new Date(this.rfpEndTime);
        },
        isInputDisabled() {
            return this.isRfpEnded || this.opportunityDetails?.vendor_status_id === 10;
        },
        showRetractButton() {
            return this.opportunityDetails?.vendor_status_id === 10;
        },

        contractUploadUrl() {
            if (this.opportunityDetails?.rfp_uuid) {
                return `${process.env.VUE_APP_RFPERFECT_FRONTEND_URL}/${this.opportunityDetails.rfp_uuid}`;
            }
            return '#';
        }
    },
    watch: {
        opportunityDetails: {
            handler(newVal) {
                console.log("opportunityDetails changed:", newVal);
                console.log("Questions:", newVal?.questions);
            },
            deep: true
        },
        // Tab navigation is no longer gated on required-field validation.
        // Vendors can move freely between pricing tables and question groups
        // (forward, backward, or skipping). The Submit Response click on the
        // final question group is the single point where mandatory fields
        // are aggregated and enforced -- see handleNext above.
    }
};
</script>

<style scoped>
.message-btn-container {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 1rem;
}

.rfp-instructions {
    background: #f8fafc;
    padding: 1rem;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    margin: 2rem auto;
}

.rfp-instructions p {
    margin: 0 0 1rem 0;
    color: #2d3748;
    line-height: 1.6;
    font-size: 0.95rem;
    max-width: 1000px;
}

.rfp-instructions p:last-child {
    margin-bottom: 0;
}

.opportunity-container {
    margin: 2rem auto;
    padding: 1rem;
}



.rfp-title {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 6px;
}

.header-section {
    background: #f8fafc;
    border-radius: 8px;
    padding: 1.5rem 1rem 1rem 1rem;
    margin-bottom: 1.5rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header-title {
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 1rem;
}

.header-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    align-items: center;
}

.opportunity-id-badge,
.timer-badge,
.date-badge {
    background: #E5F0EE;
    color: #245B5F;
    border-radius: 4px;
    padding: 6px 12px;
    font-size: 12px;
    font-weight: 500;
}

.timer-badge {
    background: #E5EDDA;
    color: #333333;
}

.timer-badge.ended {
    background: #FFE5E5;
    color: #D32F2F;
}

.date-badge-container {
    display: flex;
    gap: 8px;
}

.date-badge {
    background: #E5F0EE;
    color: #333333;
}


.intro-section,
.attachments-section,
.links-section {
    padding: 1rem;
}

.intro-title-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 1rem;
    border-bottom: 1px solid #E6E6E6;
}

.intro-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 6px;
    color: #222222;
}

.intro-subtitle {
    font-size: 14px;
    font-weight: 500;
    color: #555555
}

.intro-section,
.links-section,
.attachments-section {
    margin-bottom: 1.5rem;
}

.intro-content {
    font-size: 1rem;
    color: #2d3748;
    line-height: 1.5;
    max-height: 600px;
    overflow-y: auto;
    padding: 1rem;
}

.intro-content :deep(div) {
    margin-bottom: 1rem;
}

.intro-content :deep(strong) {
    font-weight: 600;
    color: #222222;
}

.intro-content :deep(ul) {
    list-style-type: disc;
    padding-left: 2rem;
    margin: 1rem 0;
}

.intro-content :deep(li) {
    margin-bottom: 0.5rem;
}

.intro-content :deep(em) {
    font-style: italic;
    color: #666666;
}

.intro-heading {
    font-weight: 600;
    margin-bottom: 1rem;
}

.links-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.links-list li {
    margin-bottom: 0.75rem;
}

.links-list li:last-child {
    margin-bottom: 0;
}

.links-list a {
    color: #00796b;
    text-decoration: none;
    font-size: 0.9rem;
}

.links-list a:hover {
    text-decoration: underline;
}

.attachments-list {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.attachment-item {
    margin-bottom: 0.75rem;
}

.attachment-item:last-child {
    margin-bottom: 0;
}

.file-name {
    color: #00796b;
    text-decoration: none;
    font-size: 0.9rem;
}

.file-name:hover {
    text-decoration: underline;
}

.no-data {
    color: #a0aec0;
    font-style: italic;
    font-size: 0.9rem;
}

.action-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
}

.download-excel-btn ::v-deep(.p-button-label) {
    white-space: nowrap;
}

.action-buttons .status-message {
    margin: 0 auto;
}

.status-message {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 500;
}

.status-message.declined {
    color: #D32F2F;
}

.status-message i {
    font-size: 1.25rem;
}

.pricing-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 1rem;
}

.pricing-table th,
.pricing-table td {
    border: 1px solid #e2e8f0;
    padding: 0.75rem 1rem;
    text-align: left;
}

.pricing-table th {
    background: #f8fafc;
    font-weight: 600;
}

.pricing-tables-btns-intro {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
    margin-bottom: 2rem;
}


.pricing-tables-toggle-container {
    background-color: #ffffff;
    padding: 0.5rem;
    border-radius: 6px;
    display: flex;
    gap: 0.5rem;
    overflow-x: auto;
    max-width: 80%;
    scrollbar-width: thin;
    scrollbar-color: #292B32 #ffffff;
}

/* Webkit scrollbar styles */
.pricing-tables-toggle-container::-webkit-scrollbar {
    height: 6px;
}

.pricing-tables-toggle-container::-webkit-scrollbar-track {
    background: #ffffff;
    border-radius: 3px;
}

.pricing-tables-toggle-container::-webkit-scrollbar-thumb {
    background-color: #292B32;
    border-radius: 3px;
}

.pricing-tables-toggle-container::-webkit-scrollbar-thumb:hover {
    background-color: #1a1b20;
}

.pricing-tables-toggle-container button,
.base-rate-toggle-container button {
    border: none;
    outline: none;
    background-color: #ffffff;
    color: #555555;
    padding: 0.5rem 1rem;
    white-space: nowrap;
    min-width: auto !important;
    width: auto !important;
    flex-shrink: 0;
}

.pricing-tables-toggle-container button:hover {
    background-color: #292B32;
    color: #ffffff;
}

.pricing-tables-toggle-container button.active {
    background-color: #292B32;
    color: #ffffff;
}

.pricing-tables-tabview ::v-deep(.p-tabview-nav-container) {
    display: none !important;
}

.pricing-table-section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.base-rate-search-download {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
}

.base-rate-toggle-container {
    background-color: #E5F0EE;
    padding: 0.5rem;
    border-radius: 6px;
    display: flex;
    gap: 0.5rem;
}

.base-rate-toggle-container button.baseRateActive {
    background-color: #00796b;
    color: #ffffff;
}

.message-icon {
    width: 12px;
    height: 12px;
    margin-right: 8px;
}

.base-rate-download-btn {
    background-color: #ffffff;
    color: #555555;
    border: 1px solid #E6E6E6;
    border-radius: 6px;
    width: 32px !important;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #00796b;
}

.pricing-table-section-title {
    font-size: 18px;
    font-weight: 600;
    color: #222222;
}

.skeleton-section {
    margin-bottom: 2rem;
}

.skeleton-list {
    padding-left: 2rem;
}

.mb-2 {
    margin-bottom: 0.5rem;
}

.question-cell {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.question-title {
    font-size: 0.9rem;
    color: #333;
}

/* Mandatory field styling with red border */
.mandatory-field {
    border: 1px solid #ff4d4f !important;
    /* background-color: #fff2f0 !important; */
    border-radius: 4px !important;
}

.mandatory-field:focus {
    border-color: #ff4d4f !important;
    box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2) !important;
    border-radius: 4px !important;
}

/* PrimeVue component specific mandatory field styling */
:deep(.p-inputtext.mandatory-field),
:deep(.p-dropdown.mandatory-field),
:deep(.p-multiselect.mandatory-field),
:deep(.p-calendar.mandatory-field),
:deep(.p-inputnumber.mandatory-field),
:deep(.p-textarea.mandatory-field) {
    border-color: #ff4d4f !important;
    border-radius: 4px !important;
    /* background-color: #fff2f0 !important; */
}

:deep(.p-inputtext.mandatory-field:focus),
:deep(.p-dropdown.mandatory-field:focus),
:deep(.p-multiselect.mandatory-field:focus),
:deep(.p-calendar.mandatory-field:focus),
:deep(.p-textarea.mandatory-field:focus) {
    border-color: #ff4d4f !important;
    box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2) !important;
    border-radius: 4px !important;
}

:deep(.p-inputnumber.mandatory-field:focus-within) {
    border-color: #3f51bf !important;
    border-width: 3px !important;
    border-radius: 4px !important;
}

:deep(.p-inputnumber.mandatory-field:focus-within input) {
    border-color: transparent !important;
    box-shadow: none !important;
    outline: none !important;
}

/* File upload mandatory field styling */
.file-upload-wrapper .mandatory-field+.file-upload-label {
    border-color: #ff4d4f;
    /* background-color: #fff2f0; */
}

.options-cell {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.option-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.text-input {
    width: 100%;
}

:deep(.p-datatable .p-datatable-tbody > tr > td) {
    padding: 1rem;
}

:deep(.p-checkbox) {
    margin-right: 0.5rem;
}

.company-profile-form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.company-profile-question {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.company-profile-label {
    font-weight: 600;
    color: #222;
}

.company-profile-options {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.company-profile-option {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.company-profile-input {
    width: 100%;
}

.required-input {
    display: none;
}

/* Remove the old valid-input styling since we're using mandatory-field now */

.file-upload-container {
    min-width: 150px;
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.file-upload-wrapper {
    position: relative;
    width: 100%;
}

.file-upload-input {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 2;
}

.file-upload-label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background-color: #f8f9fa;
    color: #495057;
    transition: all 0.2s ease;
}

.file-upload-label i {
    font-size: 1rem;
}

.file-upload-label:hover {
    background-color: #e9ecef;
}

.file-upload-label:hover {
    background-color: #e9ecef;
}

.file-name-container {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;
    padding: 0.75rem;
    background-color: #f8f9fa;
    border-radius: 6px;
    border: 1px solid #dee2e6;
}

/* Single line: hint + filename + actions — only as wide as content */
.file-name-container--single-line {
    display: inline-flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    gap: 0.5rem;
    padding: 0.35rem 0.5rem;
    border-radius: 6px;
    border-color: #e2e8f0;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    width: fit-content;
    max-width: 100%;
}

.file-attached-hint {
    font-size: 0.75rem;
    color: #6c757d;
    white-space: nowrap;
    flex-shrink: 0;
}

.file-name-cell {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    min-width: 0;
    flex: 0 1 auto;
    max-width: 280px;
    cursor: pointer;
    padding: 0.1rem 0;
}

.file-name-cell:hover .file-name {
    color: #0d6efd;
    text-decoration: underline;
}

.file-name-icon {
    font-size: 0.85rem;
    color: #6c757d;
    flex-shrink: 0;
}

.file-upload-container .file-name-container .file-name {
    font-size: 0.85rem;
    color: #495057;
    word-break: break-word;
    overflow-wrap: break-word;
    transition: color 0.15s ease;
}

.file-actions {
    display: flex;
    align-items: center;
    gap: 0.1rem;
    flex-shrink: 0;
}

.file-name-container--single-line .view-file-btn,
.file-name-container--single-line .remove-file-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    padding: 0 !important;
    min-width: 1rem;
    height: 1rem;
    width: 1rem;
    background: transparent !important;
    border: none !important;
    border-radius: 2px;
    box-shadow: none !important;
}

.file-name-container--single-line .view-file-btn:hover,
.file-name-container--single-line .remove-file-btn:hover {
    background: rgba(0, 0, 0, 0.06) !important;
}

.file-name-container--single-line .view-file-btn .p-button-icon,
.file-name-container--single-line .remove-file-btn .p-button-icon {
    font-size: 0.75rem;
    margin: 0 !important;
}

/* Style for valid state */
.file-upload-wrapper .valid-input+.file-upload-label {
    border-color: #52c41a;
    background-color: #f6ffed;
}

.question-group {
    margin-bottom: 2rem;
    padding: 1.5rem;
    background: #f8fafc;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
}

.question-group-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #2d3748;
    margin-bottom: 1.5rem;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid #e2e8f0;
}

.company-profile-question {
    margin-bottom: 1.5rem;
}

.company-profile-question:last-child {
    margin-bottom: 0;
}

.upload-progress {
    margin-top: 0.5rem;
    width: 100%;
}

:deep(.p-progressbar) {
    height: 0.5rem;
    background: #f0f0f0;
}

:deep(.p-progressbar .p-progressbar-value) {
    background: #00796b;
}

.retract-confirmation {
    padding: 1rem 0;
}

.retract-confirmation p {
    margin: 0;
    color: #333;
    font-size: 1rem;
    line-height: 1.5;
}

:deep(.p-calendar) {
    width: 200px;
}

:deep(.p-calendar .p-inputtext) {
    width: 100%;
}

:deep(.p-calendar-w-btn .p-datepicker-trigger.p-button) {
    background-color: #00796b !important;
    border: 0 none !important;
}

.pricing-table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
}


.nested-tables-nav {
    display: flex;
    gap: 0.5rem;
    padding: 0.5rem;
    border-radius: 6px;
    width: 600px;
    background: #E5F0EE;
    overflow-x: auto;
    scrollbar-width: thin;
    scrollbar-color: #245B5F #E5F0EE;
}

/* Webkit scrollbar styles */
.nested-tables-nav::-webkit-scrollbar {
    height: 6px;
}

.nested-tables-nav::-webkit-scrollbar-track {
    background: #E5F0EE;
    border-radius: 3px;
}

.nested-tables-nav::-webkit-scrollbar-thumb {
    background-color: #245B5F;
    border-radius: 3px;
}

.nested-tables-nav::-webkit-scrollbar-thumb:hover {
    background-color: #1a3f42;
}

.nested-table-btn {
    background-color: transparent;
    color: #333333;
    white-space: nowrap;
    min-width: auto !important;
    width: auto !important;
    flex-shrink: 0;
}

.nested-table-btn.active {
    background-color: #245B5F;
    color: #ffffff;
}

.nested-table-header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 1rem;
}

.nested-table-name {
    flex: 1;
    font-size: 0.9rem;
    color: #495057;
    word-break: break-all;
    width: 90%;
}

.add-table-btn {
    min-width: 100px !important;
}

.no-nested-table {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    color: #6c757d;
    font-style: italic;
}

.custom-sidebar-header {
    display: flex;
    align-items: center;
    height: 60px !important;
    border-bottom: 1px solid #e0e0e0;
    padding: 0px 10.5px;

}

.sidebar-header-left {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    width: 30%;
    border-right: 1px solid #e0e0e0;
    height: 100%;
    padding-right: 10.5px;
}

.sidebar-header-left .icon-btn {
    width: 3rem !important;
    background-color: #333;
}

.sidebar-header-left .sidebar-header-title,
.sidebar-header-right .sidebar-header-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
}

.sidebar-header-right {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    padding-left: 10.5px;
}

.sidebar-header-right .close-btn {
    width: 3rem !important;
    background-color: transparent;
    color: #333;
}

/* Try multiple approaches to target the header content */
:deep(.p-sidebar-header-content) {
    width: 100% !important;
}

:deep(.p-sidebar .p-sidebar-header-content) {
    width: 100% !important;
}

:deep(.p-sidebar-header) {
    width: 100% !important;
}

/* Global style as fallback */
:global(.p-sidebar-header-content) {
    width: 100% !important;
}

:global(.p-sidebar-header) {
    padding: 0 !important;
}

:global(.p-sidebar-content) {
    padding: 0 10.5px !important;
}

.sidebar-header-right-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.sidebar-header-right-container-close {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.nested-table-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.edit-confirm-btn,
.edit-cancel-btn {
    width: 2rem !important;
    height: 2rem !important;
    padding: 0.25rem !important;
    min-width: auto !important;
}

.edit-confirm-btn {
    background-color: #5cb85c !important;
    color: #fff !important;
}

.edit-cancel-btn {
    background-color: #d9534f !important;
    color: #fff !important;
}

.nested-table-edit-container {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.nested-table-edit-input {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background-color: #f8f9fa;
    color: #495057;
}

.nested-table-edit-container {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    min-width: 150px;
}

.nested-table-edit-input {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background-color: #ffffff;
    color: #495057;
    font-size: 0.9rem;
    min-width: 120px;
}

.nested-table-edit-input:focus {
    outline: none;
    border-color: #00796b;
    box-shadow: 0 0 0 2px rgba(0, 121, 107, 0.2);
}

.nested-table-item {
    display: flex;
    align-items: center;
    gap: 0.25rem;
}

.edit-confirm-btn,
.edit-cancel-btn {
    width: 2rem !important;
    height: 2rem !important;
    padding: 0.25rem !important;
    min-width: auto !important;
    border-radius: 4px !important;
}

.edit-confirm-btn {
    background-color: #28a745 !important;
    color: #fff !important;
    border: 1px solid #28a745 !important;
}

.edit-confirm-btn:hover {
    background-color: #218838 !important;
    border-color: #1e7e34 !important;
}

.edit-cancel-btn {
    background-color: #dc3545 !important;
    color: #fff !important;
    border: 1px solid #dc3545 !important;
}

.edit-cancel-btn:hover {
    background-color: #c82333 !important;
    border-color: #bd2130 !important;
}


/* Contract Instruction Styles */
.contract-instruction {
    background: linear-gradient(135deg, #E5F0EE 0%, #f8fafc 100%);
    border: 1px solid #245B5F;
    border-radius: 8px;
    padding: 1.5rem;
    margin: 2rem auto;
    box-shadow: 0 4px 12px rgba(36, 91, 95, 0.1);
}

.contract-instruction-content {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
}

.contract-icon {
    font-size: 2rem;
    color: #245B5F;
    margin-top: 0.25rem;
    flex-shrink: 0;
}

.contract-instruction-text {
    flex: 1;
}

.contract-instruction-text h4 {
    margin: 0 0 0.5rem 0;
    color: #245B5F;
    font-size: 1.25rem;
    font-weight: 600;
}

.contract-instruction-text p {
    margin: 0 0 1rem 0;
    color: #2d3748;
    line-height: 1.6;
    font-size: 0.95rem;
}

.contract-link {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    background: #245B5F;
    color: #ffffff;
    text-decoration: none;
    padding: 0.75rem 1.5rem;
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.2s ease;
    box-shadow: 0 2px 4px rgba(36, 91, 95, 0.2);
    margin-bottom: 1rem;

}

.contract-link:hover {
    background: #1a3f42;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(36, 91, 95, 0.3);
    color: #ffffff;
    text-decoration: none;
}

.contract-link i {
    font-size: 0.9rem;
}

/* Partner Contract Instructions Styles */
.partner-contract-instructions {
    padding: 0;
}

.partner-contract-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 2rem;
    padding-bottom: 1rem;
    border-bottom: 2px solid #245B5F;
}

.partner-contract-header h4 {
    margin: 0;
    color: #245B5F;
    font-size: 1.5rem;
    font-weight: 600;
}

.partner-contract-steps {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.contract-step {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 1.5rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.contract-step h5 {
    margin: 0 0 1rem 0;
    color: #245B5F;
    font-size: 1.1rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.contract-step p {
    margin: 0 0 1rem 0;
    color: #2d3748;
    line-height: 1.6;
    font-size: 0.95rem;
}

.contract-step p:last-child {
    margin-bottom: 0;
}

.contract-step ul {
    margin: 1rem 0;
    padding-left: 1.5rem;
}

.contract-step li {
    margin-bottom: 0.5rem;
    color: #2d3748;
    line-height: 1.5;
}

.customer-info {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    padding: 1rem;
    margin: 1rem 0;
}

.info-item {
    display: flex;
    gap: 2rem;
    align-items: center;
    padding: 0.5rem 0;
    border-bottom: 1px solid #e2e8f0;
}

.info-item:last-child {
    border-bottom: none;
}

.info-item strong {
    color: #245B5F;
    font-weight: 600;
    min-width: 120px;
}

.info-item span {
    color: #2d3748;
    font-weight: 500;
}

.upload-note {
    background: #fff3cd;
    border: 1px solid #ffeaa7;
    border-radius: 4px;
    padding: 0.75rem;
    margin-top: 1rem;
    color: #856404;
    font-size: 0.9rem;
}

.pricing-table-section .p-inputtext:enabled:focus {
    box-shadow: none !important;
}


:deep(.p-dropdown.p-focus) {
    border-color: #ff4d4f !important;
    box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2) !important;
}

:deep(.p-multiselect.p-focus) {
    box-shadow: none !important;
}
</style>